/* globals isClient */
import * as c from 'state/constants'
import { cloneDeep } from 'lodash/lang'
import {pick} from 'lodash/object'
import {map} from 'lodash/collection'
import underscore from 'underscore'
import moment from 'moment'
import nesProp from 'nested-property'
import Cookies from 'js-cookie';
// import {isDocumentMustBeSigned} from "./../components/DSDocuments/DSWizardHelper"

export {reducer as form} from 'redux-form'
export {default as categories} from './ducks/categories'
export {default as sources} from './ducks/sources'
export {default as text} from './ducks/text'
export {default as willdoc} from 'components/willdoc/wil-duck'
import uuidv4 from 'uuid/v4'

export const registration = (state = {}, action) => {
	switch (action.type) {
		case c.FORM_SUBMITTED:
			return {isSending: true}
		case c.REG_RESULT:
			if (action.ok) {
				return {sent: true}
			}
			return {problem: action.err}
		case c.RESET_REG:
			return {}
		default:
			return state
	}
}

const flashDefaults = {items: []}
export const flash = (state = flashDefaults, action) => {
	switch (action.type) {
		case c.GOT_FLASH:
			return {
				items: action.items,
				ts: action.ts,
			}
			// Comented out as it messes up the flases, flash method is colled evcery time metro ui is accesed
			// case c.GOT_NEWS:
			// 	return {
			// 		items: action.items.filter(item => item.newsflash || item.isFlash ),
			// 		ts: action.ts,
			// 	}
		case c.LANG_SET:
		case c.LOGGED_OUT:
			return flashDefaults
		default:
			return state
	}
}

const newsDefaults = {items: [], flash: [], filter: '', loaded: false, lastLogin: null ,newNewsCount: 0}
export const news = (state = newsDefaults, action) => {
	switch (action.type) {
		case c.GOT_NEWS:
			return {
				...state,
				// JSON dates sort lexographically
				items: action.items.sort((a, b) => b.pubStart.localeCompare(a.pubStart)),
				// flash: action.items.filter(item => item.newsflash),
				ts: action.ts,
				lastLogin: action.lastLogin,
				newNewsCount: countNewNews(action.items, action.lastLogin)
			}
		case c.NEWS_FILTERED:
			return {...state, filter: (action.filter || '')}
		case c.NEWS_LOADED:
			return {...state, loaded: true}
		case c.LOGGED_OUT:
			return newsDefaults
		case c.NEWS_SELECT:
			return {...state, opened: action.itemId}
		default:
			return state
	}
}

const countNewNews = (news, lastLogin) => {
	let newNewsCount = 0
	if(!lastLogin){
		newNewsCount = news.length
		return newNewsCount
	}
	for (let n of news ){
		if( moment(lastLogin).isBefore(n.pubStart) ){
			++newNewsCount
		}
	}
	return newNewsCount
}

const faqDefaults = {items: [], filter: ''}
export const faq = (state = faqDefaults, action) => {
	switch (action.type) {
		case c.GOT_FAQ: {
			const {items} = action
			return {...state, items}
		}
		case c.FAQ_FILTERED:
			return {...state, filter: (action.filter || '')}
		case c.LANG_SET:
		case c.LOGGED_OUT:
			return faqDefaults
		default:
			return state
	}
}

const linksDefaults = {items: [], filter: ''}
export const links = (state = linksDefaults, action) => {
	switch (action.type) {
		case c.GOT_LINKS:
			return {...state, items: action.items}
		case c.LINKS_FILTERED:
			return {...state, filter: (action.filter || '')}
		case c.LANG_SET:
		case c.LOGGED_OUT:
			return linksDefaults
		default:
			return state
	}
}

export const filterTicketsByTaskStatus = (item, status) => {
    let booleanStatus = (status === 'completed') ? true : false
    let showItem = false

    if(item && item.relatedTasks && item.relatedTasks.length) {
        item.relatedTasks.map((relatedTask, key) => {
            if(relatedTask.isCompleted === booleanStatus) {
                showItem = true
            }
        })
    }

    return showItem
}

const inboxFilters = {
	showUnread: item => item.unread,
	showRead: item => !item.unread,
    showAll: () => true,
    hasTaskCompleted: (item) => filterTicketsByTaskStatus(item, 'completed'),
    hasTaskUncompleted: (item) => filterTicketsByTaskStatus(item, 'uncompleted')
}
const calcUnread = (items) => items.reduce((a, i) => a + (i.unread ? 1 : 0), 0)
const inboxDefaults = {
	items: [], staff: [], filter: '', unreadCount: 0, selectValue: 'showAll',
	archiveData: {modalIsOpen: false, message: ''}
}
export const inbox = (state = inboxDefaults, action) => {
	switch (action.type) {
		case c.GOT_INBOX: {
			const shouldShow = inboxFilters[state.selectValue]
			const items = action.data.map((item) => {
				let documentNames = '';

				if (item.ticket.documents && item.ticket.documents.length > 0) {
					item.ticket.documents.map((documentItem) => {
						documentNames = documentNames + documentItem + ' '
					})
				}

				return {
					id: item.ticket._id,
					ticketDate: item.ticket.ticketDate,
					ticketDescription: item.ticket.ticketDescription,
					ticketType: item.ticket.ticketType,
					ticketDetails: item.ticket.ticketDetails,
					typeDocument: item.ticket.typeDocument,
					ticketDocumentNames: documentNames,
					ticketUniqueId: item.ticket.ticketRelation,
					documents: item.ticket.documents,
					unread: item.ticket.unread,
					archived: item.ticket.archived,
					hidden: !shouldShow(item.ticket),
					relatedTasks: item.tasks,
					unlinkedDocumentId: item.ticket.unlinkedDocumentId,
					unlinkedDocumentFileName: item.ticket.unlinkedDocumentFileName,
					signatureDocuments: item.ticket.signatureDocuments,
					statusFromPackage: item.ticket.statusFromPackage,
					linkedClient: item.ticket.linkedClient
				}
			})

			return {
				...state,
				items,
				unreadCount: calcUnread(items),
				ts: action.ts,
			}
		}
		case c.TICKETS_FILTERED:
			return {...state, filter: (action.filter || '')}
		case c.SET_FILTERED: {
			const {selectValue} = action
			const shouldShow = inboxFilters[selectValue]

			return {
				...state,
				items: state.items.map(item => ({...item, hidden: !shouldShow(item)})),
				selectValue,
			}
		}
		case c.INBOX_ARCHIVE_CLEAN_SELECTED_ITEMS: {
			const items = state.items

			if(items.length) {
				items.map((value,key) => {
					value.checked  = false
				})
			}

			return {...state}
		}
		case c.SET_ALL_VISIBLE_CHECKED: {
			const items = action.visibleItems
			const vI = items.length
			const cI = state.items.reduce(
				(acc, item) => acc + (item.checked && items.includes(item.id) ? 1 : 0),
				0
			)
			const toCheck = vI !== cI
			return {...state, items: state.items.map(item => ({...item, checked: items.includes(item.id) ? toCheck : item.checked}))}
		}
		case c.SET_ALL_CHECKED: {
			return {...state, items: state.items.map(item => ({...item, checked: true}))}
        }
        case c.SET_ALL_UNCHECKED: {
			return {...state, items: state.items.map(item => ({...item, checked: false}))}
		}
		case c.SET_CHECKBOX:
			return {...state, items: state.items.map(item =>
				({...item, checked: item.id === action.id ? !item.checked : item.checked})
			)}
		case c.LOGGED_OUT:
			return inboxDefaults
		case c.INBOX_ITEMS_STATUS: {
			const {ticketIds, status: {unread, archived}} = action
			const newItems = state.items.map(i => {
				if (ticketIds.includes(i.id)) {
					return {
						...i,
						unread: unread == null ? i.unread : unread,
						archived: archived == null ? i.archived : archived,
					}
				}
				return i
			})
			return {
				...state,
				items: newItems,
				unreadCount: calcUnread(newItems),
			}
		}
		case c.SET_UNREAD_NUM:
			return {...state, unreadCount: action.number}

		/**
		 *  UPDATE INBOX REDUCERS WITH THE NEW CONVERT AND ARCHIVER TOOLS
		 ******************************************************************/
		case c.INBOX_ARCHIVE_SET_STAFF_LIST: {
			let staffList = []

			if(action.response.length) {
				action.response.map((value,key) => {
					let userData = value
					userData['selected'] = false

					staffList[key] = userData
				})
			}

			return {...state, staff: staffList}
		}
		case c.INBOX_ARCHIVE_RESET_STAFF_LIST: {
			state.staff.map((value, key) => {
				if(value.selected == true) {
					value.selected = false
				}
			})

			state.archiveData.message = ''

			return {...state}
		}
		case c.INBOX_ARCHIVE_CONVERT_TICKET_SUCCESS: {
			state.archiveData = {
				modalIsOpen: false,
				message: ''
			}

			return {
				...state
			}
		}
		case c.INBOX_ARCHIVE_CONVERT_TICKET_ERROR: {
			const {archiveData} = state

			if(action.err && action.err.message) {
				archiveData.message = action.err.message
			} else {
				archiveData.message = 'Something went wrong please try again later'
			}

			return {
				...state,
				archiveData: {...archiveData}
			}
		}
		case c.INBOX_ARCHIVE_MODAL_TOGGLE: {
			let newArchiveData = state.archiveData

			newArchiveData.modalIsOpen = !state.archiveData.modalIsOpen

			return {
				...state,
				archiveData: newArchiveData
			}
        }
        case c.GET_CLIENT_ID: {
			return {
				...state,
				clientId: action.clientId
			}
        }
		default:
			return state
	}
}

/**
 * TASK MODULE REDUCERS
 *
 * Contains all reducers for task module
 **********************************************************************************************************************/
const shouldShowByStatus = {
	showCompleted: item => item.isCompleted,
	showUncompleted: item => !item.isCompleted,
	showAll: () => true,
}

const taskModuleDefaults = {
		// Task list data and filters
		items: [],
		uncompleted: 0,
		filter: '',
		filterStatusValue: 'showAll',
		filterColorValue: [],

		// Colors list data
		colorsList: {
			userColors: [],
			defaultColors: [],
		},

		// Task form data
		manageTask: {
			message: null,
			status: null,
			taskId: null,
			isEdit: false,
		},

		// Manage colors form data
		manageColors: {
			message: null,
			status: null,
		},

		// Color picker form data
		manageColorPicker: {
			message: null,
			status: null,
			colorId: null,
			isEdit: false,
		},

		notification: {
			type: '',
			itemId: null,
		},

		// Todo module modals states
		modals: {
			manageTask: false,
			manageColors: false,
			manageColorPicker: false,
			notification: false,
			sendTask: false,
		}
}

// Function to calculate how many uncompleted task we have
const calcUncompleted = (items) => {
	return items.filter(item => !item.isDeleted).reduce((accumulator, currentValue, currentIndex, array) =>  {
		if(currentValue.isCompleted == false)
		{
			let currentDate = moment().set({hour:0, minute: 0, second: 0, millisecond: 0})
			let itemEndDate = moment(currentValue.endDate)

			if(itemEndDate.isBefore(currentDate) || itemEndDate.isSame(currentDate))
			{
				accumulator++
			}
		}

		return accumulator
	},0)
}

// Checks if item can be showable or not based on filters
const shouldShowTask = (item, filterStatusValue, filterColorValue) => {
	let response = null;

	// Filter items based on filter status value
	const shouldShowBS = shouldShowByStatus[filterStatusValue]
	response = shouldShowBS(item)

	// Filter items based on filterColorValue
	// Note that this variable is an array with multiple objects if any color is selected
	if(underscore.isArray(filterColorValue) && filterColorValue.length > 0)
	{
		if(response == false)
		{
			return response
		}

		let showable = false;

		filterColorValue.map((value,index) => {
			if(value.value == item.colorCode) {
				showable = true;
			}
		})

		return showable;
	}

	return response;
}

const setColorHex = (colorId, colorsList) => {
	const colorsArray = [
		...colorsList.defaultColors,
		...colorsList.userColors
	]

	if(colorId == null)
	{
		return null;
	}


	let response = null;

	colorsArray.map((value) => {
		if(value.value == colorId)
		{
			response = value.colorCode
		}
	})

	return response;
}

/**
 * Task list reducer group where we listen to every action dispached
 */
export const taskList = (state = taskModuleDefaults, action) => {
	switch (action.type) {
		/**
		 * TASK LIST MANAGER
		 *
		 * Contains all action listeners that manage the lists like task,taskDefaultColors, taskUserColors
		 */
		case c.TASK_MODULE_LIST_SET: {
			const items = action.tasks.map(item => {

                if (item.task.endDate && !moment(item.task.endDate).isValid()) {
                    console.error("Invalid end date for task id:",item.task._id, " -> ", item.task.endDate)
                }

                return {
                    id: item.task._id,
                    ticketReferral: item.task.ticketReferral,
                    taskRelation: item.task.taskRelation,
                    title: item.task.title,
                    description: item.task.description,
                    colorCode: item.task.colorCode,
                    endDate: item.task.endDate || "",
                    isCompleted: item.task.isCompleted,
                    isDeleted: item.task.isDeleted,
                    isUnreaded: item.task.isUnreaded,
                    ticketDocuments: item.task.ticketDocuments,
                    ticketDoctype: item.task.ticketDoctype,
                    createdAt: item.task.createdAt,
                    hexColor: setColorHex(item.task.colorCode, state.colorsList),
                    hidden: !shouldShowTask(item.task, state.filterStatusValue, state.filterColorValue),
                    checked: false,
                    globalSort: (item.task.endDate || "") + '|' + item.task.isCompleted,
                    relations: item.relations,
                    receivedFrom: item.receivedFrom,
                    //userRelation: item.task.userRelation
                }
            })
			return {
				...state,
				items,
				uncompleted: calcUncompleted(items),
			}
		}
		case c.TASK_MODULE_LIST_DEFAULT_COLORS_SET: {
			let colorsList = {
				userColors: state.colorsList.userColors,
				defaultColors: state.colorsList.defaultColors
			}

			const defaultColors = action.taskColors.map(item => ({
				value: item._id,
				label: item.title,
				colorCode: item.colorCode
			}))

			colorsList.defaultColors = defaultColors

			return {
				...state,
				colorsList
			}
		}
		case c.TASK_MODULE_LIST_USER_COLORS_SET: {
			let colorsList = {
				userColors: state.colorsList.userColors,
				defaultColors: state.colorsList.defaultColors
			}

			const userColors = action.taskColors.map(item => ({
				value: item._id,
				label: item.title,
				colorCode: item.colorCode
			}))

			colorsList.userColors = userColors

			return {
				...state,
				colorsList
			}
		}
		case c.TASK_MODULE_FILTER: {
			let { filterStatusValue, filterColorValue} = action.filterOptions

			filterColorValue.map((value,index) => {
				if(value.value == 'reset_filter')
				{
						filterColorValue = []
				}
			})

			return {
				...state,
				items: state.items.map(item => ({...item, hidden: !shouldShowTask(item, filterStatusValue, filterColorValue)})),
				filterStatusValue,
				filterColorValue
			}
		}
		case c.TASK_MODULE_FILTER_CLEAN: {
			const { userColors, defaultColors } = state.colorsList
			let { filterColorValue } = state

			const colorsData = [
				...userColors,
				...defaultColors
			]

			let newFilterData = []

			filterColorValue.map((value, key) => {
					let isColor = false

					colorsData.map((colorValue, colorKey) => {
							if(value.value == colorValue.value)
							{
									isColor = true
							}
					})

					if(isColor == true)
					{
							newFilterData.push(value)
					}
			})

			filterColorValue = newFilterData

			return {
				...state,
				filterColorValue
			}
		}

		/**
		 * MODALS MANAGER
		 *
		 * Contains all action listeners that manage modal
		 */
		case c.TASK_MODULE_MODAL_TOGGLE: {
			const modals = {
				manageTask: state.modals.manageTask,
				manageColors: state.modals.manageColors,
				manageColorPicker: state.modals.manageColorPicker,
				notification: state.modals.notification,
				sendTask: state.modals.sendTask
			}

			if(action.modalType == c.TASK_MODULE_MODAL_NAME_MANAGE_TASK)
			{
				modals.manageTask = !state.modals.manageTask
			}

			if(action.modalType == c.TASK_MODULE_MODAL_NAME_MANAGE_COLORS)
			{
				modals.manageColors = !state.modals.manageColors
			}

			if(action.modalType == c.TASK_MODULE_MODAL_NAME_MANAGE_COLOR_PICKER)
			{
				modals.manageColorPicker = !state.modals.manageColorPicker
			}

			if(action.modalType == c.TASK_MODULE_MODAL_NAME_NOTIFICATION)
			{
				modals.notification = !state.modals.notification
			}

			if(action.modalType == c.TASK_MODULE_MODAL_NAME_SEND_TASK)
			{
				modals.sendTask = !state.modals.sendTask
			}

			return {
				...state,
				modals
			}
		}
		case c.TASK_MODULE_MODAL_NOTIFICATION_SET: {
			const notification = {
				type: action.notificationData.notificationType,
				itemId: action.notificationData.itemId,
			}

			return {
				...state,
				notification
			}
		}
		case c.TASK_MODULE_MODAL_NOTIFICATION_RESET: {
			const notification = {
				type: '',
				itemId: null,
			}

			return {
				...state,
				notification
			}
		}

		/**
		 * TASK FORM MANAGER
		 *
		 * Contains all action listeners that manage task forms
		 */
		case c.TASK_MODULE_FORM_ERROR: {
			if(action.response.formType == 'manageTask')
			{
				let manageTask = {
					message: state.manageTask.message,
					status: state.manageTask.status,
					taskId: state.manageTask.taskId,
					isEdit: state.manageTask.isEdit
				}

				if(action.response.error)
				{
					manageTask.status = false
					manageTask.message = action.response.error.error.message
				}

				return {
					...state,
					manageTask
				}
			}

			if(action.response.formType == 'manageColorPicker')
			{

			}
		}
		case c.TASK_MODULE_FORM_CLEAN: {
			if(action.formType == 'manageTask')
			{
				const manageTask = {
					message: null,
					status: null,
					taskId: null,
					isEdit: false,
				}

				return {
					...state,
					manageTask
				}
			}

			if(action.formType == 'manageColors')
			{
				const manageColors = {
					message: null,
					status: null,
				}

				return {
					...state,
					manageColors
				}
			}

			if(action.formType == 'manageColorPicker')
			{
				const manageColorPicker = {
					message: null,
					status: null,
					colorId: null,
					isEdit: false,
				}

				return {
					...state,
					manageColorPicker
				}
			}
		}
		case c.TASK_MODULE_FORM_CLEAN_MESSAGE: {
			if(action.formType == 'manageTask')
			{
				const manageTask = {
					message: null,
					status: null,
					taskId: state.manageTask.taskId,
					isEdit: state.manageTask.isEdit,
				}

				return {
					...state,
					manageTask
				}
			}

			if(action.formType == 'manageColors')
			{
				const manageColors = {
					message: null,
					status: null,
				}

				return {
					...state,
					manageColors
				}
			}

			if(action.formType == 'manageColorPicker')
			{
				const manageColorPicker = {
					message: null,
					status: null,
					colorId: null,
					isEdit: false,
				}

				return {
					...state,
					manageColorPicker
				}
			}

			return {
				...state
			}
		}
		case c.TASK_MODULE_FORM_EDIT_SET: {
			const {formType, entityId } = action.response

			if(formType == 'manageTask')
			{
				const manageTask = {
					message: state.manageTask.message,
					status: state.manageTask.status,
					taskId: entityId,
					isEdit: true,
				}

				return {
					...state,
					manageTask
				}
			}

			if(formType == 'manageColorPicker')
			{
				const manageColorPicker = {
					message: state.manageColorPicker.message,
					status: state.manageColorPicker.status,
					colorId: entityId,
					isEdit: true,
				}

				return {
					...state,
					manageColorPicker
				}
			}
		}

		/**
		 * TASK TABLE LIST CHECKBOX MANAGER
		 *
		 * Contains all action listeners that manage task table list checkbox items
		 */
		case c.TASK_MODULE_ITEM_SET_CHECK: {
			return {...state, items: state.items.map(item =>
				({...item, checked: item.id === action.itemId ? !item.checked : item.checked})
			)}
		}
		case c.TASK_MODULE_ITEM_SET_CHECK_ALL_VISIBLE: {
			const items = action.visibleItems
			const vI = items.length
			const cI = state.items.reduce(
				(acc, item) => acc + (item.checked && items.includes(item.id) ? 1 : 0),
				0
			)
			const toCheck = vI !== cI
			return {...state, items: state.items.map(item => ({...item, checked: items.includes(item.id) ? toCheck : item.checked}))}
        }
        case c.TASK_MODULE_ITEM_READED: {
            state.items.map((value,key) => {
                if(value.id === action.response._id) {
                    value.isUnreaded = false
                }
            })

            return  {
                ...state
            }
        }


		/**
		 * Returns the default state for default switch case
		 */
		default:
			return state
    }
}

/******************************************************
 * OUTBOX SECTION
 ******************************************************/

const outboxFilters = {
	showSent: item => item.status == 'sent',
	showUnSent: item => item.status !== 'sent',
	showAll: () => true,
}
const shouldShowByDates = (item, startDate, endDate) => {
    let should = !item.hidden
    // try to prevent the deprecated ISO format warning but not yet we need new modules :)
    /* var dateString = startDate &&
        startDate.getUTCFullYear() + "/" +
        ("0" + (startDate.getUTCMonth()+1)).slice(-2) + "/" +
        ("0" + startDate.getUTCDate()).slice(-2) + " " +
        ("0" + startDate.getUTCHours()).slice(-2) + ":" +
        ("0" + startDate.getUTCMinutes()).slice(-2) + ":" +
        ("0" + startDate.getUTCSeconds()).slice(-2) || undefined */
    // skipping the time comparation
    let mStartDate = moment(moment(startDate).format("DD-MM-YYYY"), "DD-MM-YYYY")
    let mEndDate = moment(moment(endDate).format("DD-MM-YYYY"), "DD-MM-YYYY")
    const sentDate = moment(moment(item.sentDate).format("DD-MM-YYYY"), "DD-MM-YYYY")
    if(startDate && mStartDate.isValid()) {
        should = should && (!mStartDate.isAfter(sentDate) || mStartDate.isSame(sentDate))
    }
    if(endDate && mEndDate.isValid()) {
        should = should && (mEndDate.isAfter(sentDate) || mEndDate.isSame(sentDate))
    }
    return should
}
const calcOutboxFailed = (items) => items.reduce(
    (a, i) =>
        a + (((i.status == 'failed' || i.status == 'bounced') && !i.wasResent) ? 1 : 0)
    , 0)
const outboxDefaults = {items: [], filter: '', outboxFailedCount: 0, selectValue: 'showAll', subModule: '',
    opened: ''/* , startDate: {value:''}, endDate: {value:''} */}
export const outbox = (state = outboxDefaults, action) => {
    switch (action.type) {
        case c.SET_APP_MODULE: // reset some values
            return {...state, subModule: outboxDefaults.subModule, opened: outboxDefaults.opened}
        case c.GOT_OUTBOX: {
            const shouldShow = outboxFilters[state.selectValue]
            const items = action.data.map(item => ({
                ...item,
                id: item._id,
                hidden: !shouldShow(item),
            })).map(item => ({...item, hidden: !shouldShowByDates(
                    item, state.startDate, state.endDate
                )}
            ))
            return {
                ...state,
                items,
                outboxFailedCount: calcOutboxFailed(items),
                ts: action.ts,
            }
        }
        case c.SET_OUTBOX_SUB_MODULE: {
			const {name, subModuleZoom} = action
			return {...state, subModule: name, subModuleZoom}
		}
		case c.OUTBOX_ITEM_ZOOMED:
			return {...state, opened: action.itemId}
        case c.TICKETS_FILTERED:
            return {...state, filter: (action.filter || '')}
        case c.OUTBOX_SET_FILTERED: {
            const {selectValue, startDate, endDate} = action
            const shouldShow = outboxFilters[selectValue] || (() => true)
            return {
                ...state,
                items: state.items
                    .map(item => ({...item, hidden: !shouldShow(item)}))
                    .map(item => ({...item, hidden: !shouldShowByDates(
                            item, startDate, endDate
                        )}
                    )),
                selectValue: selectValue || state.selectValue,
                startDate: (startDate === false) ? null : (startDate ? startDate : state.startDate), // if undefined -> reset
                endDate:  (endDate === false) ? null : (endDate ? endDate : state.endDate),
            }
        }
        case c.SET_ALL_VISIBLE_CHECKED: {
            const items = action.visibleItems
            const vI = items.length
            const cI = state.items.reduce(
                (acc, item) => acc + (item.checked && items.includes(item.id) ? 1 : 0),
                0
            )
            const toCheck = vI !== cI
            return {...state, items: state.items.map(item => ({...item, checked: items.includes(item.id) ? toCheck : item.checked}))}
        }
        case c.SET_ALL_CHECKED: {
            return {...state, items: state.items && state.items.map(item => ({...item, checked: true})) || []}
        }
        case c.SET_CHECKBOX:
            return {...state, items: state.items.map(item =>
                ({...item, checked: item.id === action.id ? !item.checked : item.checked})
            )}
        case c.LOGGED_OUT:
            return outboxDefaults
        case c.OUTBOX_ITEMS_STATUS: {
            const {emailIds, status: {archived}} = action
            const newItems = state.items.map(i => {
                if (emailIds.includes(i.id)) {
                    return {
                        ...i,
                        archived: archived == null ? i.archived : archived,
                    }
                }
                return i
            })
            return {
                ...state,
                items: newItems
            }
        }
        default:
            return state
    }
}
/******************************************************
 * END OF OUTBOX SECTION
 ******************************************************/

const agendaDefaults = {subscribers: [], events: []}
export const agenda = (state = agendaDefaults, action) => {
	switch (action.type) {
		case c.SET_AGENDA_DATA: {
			const items = action.response
			return {...state, events: items}
		}
		case c.GOT_USERS: {
			return {...state, users: action.response}
		}
		case c.SET_SUBSCRIBERS:
			return {...state, subscribers: action.subscriberIds}
		default:
			return state
	}
}

const officeDefaults = {brokers: {}, accountManagers: [], contacts: null, contactModal: {visible: false, contactId: null},
 contactZoom: {visible: false, contactId: null}, signatures: null, signatureZoom: {visible: false, signatureId: null}}
export const office = (state = officeDefaults, action) => {
	switch (action.type) {
		case c.FETCHED_CONTACTS:
			return {...state, contacts: action.contacts}
		case c.SET_OFFICE_DATA:
			return {...state, brokers: action.brokers, accountManagers: action.accountManagers}
		case c.SHOW_CONTACT_MODAL:
			return {...state, contactModal: {visible: true, contactId: action.id}}
		case c.HIDE_CONTACT_MODAL:
			return {...state, contactModal: {visible: false, contactId: null}}
		case c.ZOOM_CONTACT:
			return {...state, contactZoom: {visible: true, contactId: action.id}}
		case c.CLOSE_CONTACT:
            return {...state, contactZoom: {visible: false, contactId: null}}

        case c.FETCHED_SIGNATURES:
            return {...state, signatures: action.signatures}
        case c.ZOOM_SIGNATURE:
			return {...state, signatureZoom: {visible: true, signatureId: action.id}}
		case c.CLOSE_SIGNATURE:
			return {...state, signatureZoom: {visible: false, signatureId: null}}
		case c.LOGGED_OUT:
			return officeDefaults
		default:
			return state
	}
}

export const finances = (state = {items: []}, action) => {
	switch (action.type) {
		case c.FETCHED_OFFICE_FINANCES: {
			const summary = pick(action.data, ['annualCommission', 'commission', 'newCredit', 'newDebit', 'oldCredit', 'oldDebit'])
			return {...state, items: action.data.transactions, documents: action.data.documents, summary}
		}
		default:
			return state
	}
}

export const adminDocs = (state = {}, action) => {
	switch (action.type) {
		case c.FETCHED_ADMIN_DOCS: {
			return {...state, [action.brNr]: action.data}
		}
		case c.SET_ADMIN_DICT:
			return {...state, dict: action.dict}
		default:
			return state
	}
}

const uploadsDefaults = {dict: null, uploadInfo: null, modalIsOpen: false, step: 0, groupId: null, uploadType: '', uploadTypeId: '', uploadId: '', claimWizardDocType: '', dsDocumentTemplates: [],
comment: '', error: false, done: false, unallocatedFiles: []}
export const uploads = (state = uploadsDefaults, action) => {
	switch (action.type) {
		case c.SET_UPLOAD_DICT:
			return {...state, dict: action.dict}
		case c.SHOW_UPLOAD_MODAL: {
			const uploadInfo = map(action.uploadInfo, (uType, uId) => {
				const result = {}
				result.id = uId
				result.title = state.dict.uploadType[uId]
				let increment = 0
				result.fileTypes = map(uType, (fType, fId) =>{
					// TO DO I have no translations for tarification.... need dicts for this to wrok in case of tarification
					/* if(action.uploadType === 'tarification'){
						return {id: fId, title: `test ${++increment}`, max: 1, min: 0}
					} */
					return {id: fId, title: state.dict[action.uploadType][fId], max: fType.max, min: fType.min}
				})
				result.fileTypes.sort((a, b) => a.title[defaultLang].localeCompare(b.title[defaultLang]))
				return result
			})
			let step = 0
			let groupId = null
			if (action.claimWizardDocType) {
				step = 1
				for (const item of uploadInfo) {
					if (item.fileTypes && item.fileTypes.length > 0 && item.fileTypes.some(fileType => fileType.id === action.claimWizardDocType)) {
						groupId = item.id
						break
					}
				}
			}
			return { ...state, step, groupId, modalIsOpen: true, uploadInfo, uploadType: action.uploadType, uploadTypeId: action.uploadTypeId, claimWizardDocType: action.claimWizardDocType}
		}
		case c.HIDE_UPLOAD_MODAL:
			return {...state, modalIsOpen: false}
		case c.GO_TO_FILE_FORM:
			return {...state, step: 1, groupId: action.groupId, uploadId: action.uploadId, comment: action.comment}


        case c.GO_BACK_TO_UPLOAD_TYPE: {
            //cleanup the already added files
            const files = state.uploadInfo.map(info => {
				return {
					...info,
					fileTypes: info.fileTypes.map(filetype => {
						return {
							...filetype,
							files: [],
						}
					}),
				}
			})
            return {...state, modalIsOpen: true, step: 0, uploadInfo: files, comment: '', error: false, done: false, unallocatedFiles: []}
        }


        case c.SET_UPLOAD_ID:
			return {...state, uploadId: action.uploadId}
		case c.CHANGE_FILE_DATE: {
			if (action.filetype) {
				const files = state.uploadInfo.map(info => {
					if (info.id !== state.groupId) { return info }
					return {
						...info,
						fileTypes: info.fileTypes.map(filetype => {
							if (filetype.id !== action.filetype) { return filetype }
							return {
								...filetype,
								files: filetype.files.map(file => {
									if (action.file !== file) { return file }
									return { ...file, lastModified: action.date }
								}),
							}
						}),
					}
				})
				return { ...state, uploadInfo: files }
			} else {
				const filesFromState = [...state.unallocatedFiles]
				const newFiles = filesFromState.map(oneFile => {
					if (action.file !== oneFile) { return oneFile }
					return { ...oneFile, lastModified: action.date }
				})

				return { ...state, unallocatedFiles: newFiles }
			}
		}
		case c.REMOVE_FILE: {
			const unallocatedFiles = [...state.unallocatedFiles]
			const remIndex = unallocatedFiles.indexOf(action.file)
			const files = state.uploadInfo.map(info => {
				if (info.id !== state.groupId) { return info }
				return {
					...info,
					fileTypes: info.fileTypes.map(fileType => {

						if (fileType.id !== action.fileType) { return fileType }
						return {
							...fileType,
							files: fileType.files.filter(file => (action.file !== file)),
						}
					}),
				}
			})

			if(remIndex > -1) {
				unallocatedFiles.splice(remIndex, 1)
			}
			return { ...state, unallocatedFiles, uploadInfo: files }
		}

		case c.ADD_FILES: {
			const filesFromState = state.unallocatedFiles
			const uploadInfo = state.uploadInfo
			const newFilesToState = [...filesFromState]
			const filesToAllocate = []
			for (const oneFile of action.files) {
				if(oneFile.origin && oneFile.origin === 'DS_ORIGIN_ORACLE' && oneFile.documentToLowValue) {
					filesToAllocate.push(oneFile)
				} else {
					newFilesToState.push(oneFile)
				}
			}

			const newUi = uploadInfo.map((item) => {
				if (item.id === state.groupId) {
					const newTypes = item.fileTypes.map((fT) => {
						const fileIndex = filesToAllocate.findIndex(oneFile => oneFile.documentToLowValue === fT.id)
						if (fileIndex > -1) {
							const newFiles = [...(fT.files || []), filesToAllocate[fileIndex]]
							return { ...fT, files: newFiles }
						}
						return fT
					})
					return { ...item, fileTypes: newTypes }
				}
				return item
			})
			return { ...state, unallocatedFiles: newFilesToState, uploadInfo: newUi }
		}
		case c.UN_ALLOCATE_FILE: {
			const files = state.uploadInfo.map(info => {
				if (info.id !== state.groupId) { return info }
				return {
					...info,
					fileTypes: info.fileTypes.map(fileType => {

						if (fileType.id !== action.fileType) { return fileType }
						return {
							...fileType,
							files: fileType.files.filter(file => (action.file !== file)),
						}
					}),
				}
			})

			return { ...state, uploadInfo: files }
		}
		case c.ALLOCATE_FILE: {
			const uI = state.uploadInfo
			const filesFromState = state.unallocatedFiles
			const newFilesToState = [...filesFromState]
			const newUi = uI.map((item) => {
				if (item.id === state.groupId) {
					const newTypes = item.fileTypes.map((fT) => {
						if (fT.id === action.typeId) {
							const newFiles = [...(fT.files || []), action.file]
							return { ...fT, files: newFiles }
						}
						return fT
					})
					return { ...item, fileTypes: newTypes }
				}
				return item
			})
			const indexOfAllocatedFile = newFilesToState.indexOf(action.file)
			if (indexOfAllocatedFile > -1) {
				newFilesToState.splice(indexOfAllocatedFile, 1)
			}
			return { ...state, uploadInfo: newUi, unallocatedFiles: newFilesToState  }
		}
		case c.UPLOAD_PROGRESS: {
			const files = state.uploadInfo.map(info => {
				if (info.id !== state.groupId) {return info}
				return {
					...info,
					fileTypes: info.fileTypes.map(filetype => {
						if (filetype.id !== action.filetype) {return filetype}
						return {
							...filetype,
							files: filetype.files.map(file => {
								if (action.fileId !== file.fileId) {return file}
								return {...file, progress: action.progress}
							}),
						}
					}),
				}
			})
			return {...state, uploadInfo: files}
		}
		case c.UPLOAD_DONE: {
			if (!state.uploadInfo) { return state }

            // merge new info into the list of files
			const uploadInfo = state.uploadInfo.map(info => {

                // When the upload group is different then nothing to do, iterate forward the loop until match
				if (info.id !== state.groupId) {return info}

                // the groupId is the same, then merge the new info to the store
				return {
					...info, // kepp the original info and add the followings below
					fileTypes: info.fileTypes.map(filetype => {

                        // if the file id is differ, nothing to merge, continue iteration
						if (filetype.id !== action.filetype) {
                            return filetype
                        }

						return {
							...filetype, // keep the original fileType info, overwrite the followings below.

                            // iterate the files it self...
							files: filetype.files.map(file => {
								if (action.fileId !== file.fileId) {return file} // other file, skip this iteration
                                // this is the final branch of the big tree of upload madness, here you kan put custom information near your file.
								return {
                                    ...file,
                                    apiResponse: action.response,
                                    done: true
                                }
							}),
						}
					}),
				}
			})
			const done = uploadInfo.every(u => (
				u.fileTypes ? (
					u.fileTypes.every(ft => (
						ft.files ? ft.files.filter(f => f.fileId).every(f => f.done) : true
					))
				) : true
			))
			return {...state, uploadInfo, done}
		}
		case c.UPLOAD_ERROR: {
			if (!state.uploadInfo) { return state }
			const files = state.uploadInfo.map(info => {
				if (info.id !== state.groupId) {return info}
				return {
					...info,
					fileTypes: info.fileTypes.map(filetype => {
						if (filetype.id !== action.filetype) {return filetype}
						return {
							...filetype,
							files: filetype.files.map(file => {
								if (action.fileId !== file.fileId) {return file}
								return {...file, error: action.error || true}
							}),
						}
					}),
				}
			})
			return {...state, uploadInfo: files, error: true}
		}
		case c.UPLOAD_CLEAR_ERROR: {
			if (!state.uploadInfo) { return state }
			const files = state.uploadInfo.map(info => {
				if (info.id !== state.groupId) {return info}
				return {
					...info,
					fileTypes: info.fileTypes.map(filetype => {
						if (filetype.id !== action.filetype) {return filetype}
						return {
							...filetype,
							files: filetype.files.map(file => {
								if (action.fileId !== file.fileId) {return file}
								return {...file, error: false}
							}),
						}
					}),
				}
			})
			return {...state, uploadInfo: files, error: false}
		}
		case c.START_UPLOAD:
			return {...state, step: 2}
		case c.CANCEL_UPLOAD:
            return {...uploadsDefaults, dict: state.dict}
        case c.UPDATE_UPLOAD_COMMENT:
            return  {...state, comment: action.comment}
		default:
			return state
	}
}

const filesDefaults = {
	client: {},
	claim: {},
	contract: {},
	tarification: {},
}
export const files = (state = filesDefaults, action) => {
	switch (action.type) {
		case c.GET_UPLOADS:
			return {
				...state,
				[action.uploadType]: {
					...state[action.uploadType],
					[action.typeId]: {ts: Date.now(), files: action.files},
				},
			}
		case c.CLIENT_FILE_DOC_UPDATE_BEM_COMMENT: {
			const { uploadType, typeId, uploadId, documentId, bemComment } = action
			const files = cloneDeep(state[uploadType][typeId].files) // clone files to avoid mutation
			const fileIndex = files.findIndex(f => f.uploadId === uploadId)
			if (fileIndex !== -1) {
				const { commentKey, commentValue } = bemComment
				const documents = cloneDeep(files[fileIndex].documents) // clone documents to avoid mutation
				const documentIndex = documents.findIndex(d => d.documentId === documentId)
				if (documentIndex !== -1) {
					documents[documentIndex][commentKey] = commentValue
					files[fileIndex].documents = documents
				}
			}
			return {
				...state,
				[uploadType]: {
					...state[uploadType],
					[typeId]: {ts: Date.now(), files},
				},
			}
		}
		case c.CONTRACT_FILE_DOC_UPDATE_BEM_COMMENT: {
			const { typeId: contractId, uploadId, uploadType, documentId, bemComment } = action
			const files = cloneDeep(state[uploadType][contractId].files) // clone files to avoid mutation
			const fileIndex = files.findIndex(f => f.uploadId === uploadId)
			if (fileIndex !== -1) {
				const { commentKey, commentValue } = bemComment
				const documents = cloneDeep(files[fileIndex].documents) // clone documents to avoid mutation
				const documentIndex = documents.findIndex(d => d.documentId === documentId)
				if (documentIndex !== -1) {
					documents[documentIndex][commentKey] = commentValue
					files[fileIndex].documents = documents
				}
			}
			return {
				...state,
				[uploadType]: {
					...state[uploadType],
					[contractId]: {ts: Date.now(), files},
				},
			}
		}
		case c.CLAIM_FILE_DOC_UPDATE_BEM_COMMENT: {
			const { typeId: claimId, uploadId, uploadType, documentId, bemComment } = action
			const files = cloneDeep(state[uploadType][claimId].files) // clone files to avoid mutation
			const fileIndex = files.findIndex(f => f.uploadId === uploadId)
			if (fileIndex !== -1) {
				const { commentKey, commentValue } = bemComment
				const documents = cloneDeep(files[fileIndex].documents) // clone documents to avoid mutation
				const documentIndex = documents.findIndex(d => d.documentId === documentId)
				if (documentIndex !== -1) {
					documents[documentIndex][commentKey] = commentValue
					files[fileIndex].documents = documents
				}
			}
			return {
				...state,
				[uploadType]: {
					...state[uploadType],
					[claimId]: {ts: Date.now(), files},
				},
			}
		}
		case c.LOGGED_OUT:
			return filesDefaults
		default:
			return state
	}
}

export const claims = (state = [], action) => {
	switch (action.type) {
		case c.SET_CLAIMS_DATA:
			// if we have too many rows error, don't run map, as there are no items returned
			// for sure.
			if (underscore.isArray(action.response) && action.response[0] === 'Too many rows') {
				return action.response
            }

            let newState = action.response.map(item =>
                item.main.claimId ?
                    item :
                    {
                        main: {...item.main, claimId: item.main.claimNumber},
                        details: item.details,
                        documents: item.documents,
                    }
            )

            return newState
		default:
			return state
	}
}

const contractsDefaults = {}
export const contracts = (state = contractsDefaults, action) => {
	switch (action.type) {
		case c.SET_CLIENTS_DATA:
			return contractsDefaults
		case c.SET_CLIENT_DATA: {
			const newContracts = {...state}
            let changed = false
            if (action.response.contracts) {
                for (const c of action.response.contracts) {
                    const contract = c.contractMain
                    if (!newContracts[contract.contractId]) {
                        newContracts[contract.contractId] = contract
                        changed = true
                    }
                }
            }
			if (changed) {return newContracts}

			return { ...state }
		}
		case c.FETCHED_CLIENT_CONTRACT: {
			const originalContract = state[action.contractId]
			const contract = {
				...originalContract,
				...action.response.contractMain,
				contractId: action.contractId,
				details: action.response.contractDetails,
				documents: action.response.contractDocuments,
            }

            // the language flags from oracle are d = dutch, f = french, e = english.
            let langFlag = nesProp.get(action, "response.contractDetails.contractManagerLanguage")
            langFlag = (langFlag == 'd') ? 'nl' :
                ((langFlag == 'f') ? 'fr' : 'en')

			return {
                ...state,
                [action.contractId]: contract,
				contractManagerLanguage: langFlag,
				contractManagerMail: nesProp.get(action, "response.contractDetails.contractManagerMail"),
			}
		}
		case c.CONTRACT_DOCUMENT_DOC_UPDATE_BEM_COMMENT: {
			const { typeId: contractId, uploadId, bemComment } = action
			const contract = cloneDeep(state[contractId]) // clone contract to avoid mutation
			const documentIndex = contract.documents.findIndex(d => d.contractDocumentId === uploadId)
			if (documentIndex !== -1) {
				const { commentKey, commentValue } = bemComment
				contract.documents[documentIndex][commentKey] = commentValue
			}
			return {
				...state,
				[contractId]: contract,
			}
		}
		case c.LOGGED_OUT:
			return contractsDefaults
		default:
			return state
	}
}

/**
 * Fetch the claim manager details to an array
 * @param {*} claims
 */
const fetchClaimManagerDetails = (claims) => {
    let claimsManagersDetails = []

    if( !(claims && Array.isArray(claims) && claims.length > 0) ) {
        return []
    }

    // iterate claims to collect email addresses for email sender.
    claims.forEach((claimElem)=>{
        let claimId = nesProp.get(claimElem, "claimMain.claimId")
        let claimNumber = nesProp.get(claimElem, "claimMain.claimNumber")
        let claimsManagerMail = nesProp.get(claimElem, "claimMain.claimsManagerMail")
        let claimsManager = nesProp.get(claimElem, "claimMain.claimsManager")
        let claimsManagerLanguage = nesProp.get(claimElem, "claimMain.claimsManagerLanguage")

        claimId = claimId || nesProp.get(claimElem, "main.claimId")
        claimNumber = claimNumber || nesProp.get(claimElem, "main.claimNumber")
        claimsManagerMail = claimsManagerMail || nesProp.get(claimElem, "main.claimsManagerMail")
        claimsManager = claimsManager || nesProp.get(claimElem, "main.claimsManager")
        claimsManagerLanguage = claimsManagerLanguage || nesProp.get(claimElem, "main.claimsManagerLanguage")

        claimsManagersDetails.push({
            email: claimsManagerMail,
            name: claimsManager,
            lang: claimsManagerLanguage === 'd' ? 'nl' : 'fr',
            claimId,
            claimNumber
        })

        // the following code used for filter doubles but must filter at the last step.
        /*
        // if we have the same email address we don't need to add again
        let alreadyAdded = claimsManagersDetails.length > 0
            && claimsManagersDetails.filter((alreadyFilterValue)=>{
                let email  = nesProp.get(alreadyFilterValue, "email")
                return (String(email).localeCompare(claimsManagerMail) === 0)
                // && (alreadyFilterValue.name.localeCompare( claimElem.claimMain.claimsManager) === 0)
        })

        // TODO get a list of language codes of oracle languages: 'd', ... ??? insert in common preference
        // add the claim manager email to the list if unique the email address
        if(!alreadyAdded || (Array.isArray(alreadyAdded) && alreadyAdded.length == 0)) {
            claimsManagersDetails.push({
                email: claimsManagerMail,
                name: claimsManager,
                lang: claimsManagerLanguage === 'd' ? 'nl' : 'fr',
                claimId,
                claimNumber
            })
        } */
    })

    return claimsManagersDetails
}

const clientsDefaults = {
	data: null, clientData: {}, subModule: "",
	finances: {}, claims: {}, subModuleZoom: {}, initialArguments: {}, tarifications: {},
	filter: {}, selectedCheckboxes: {}, formStatus: { isSending: false, sent: false, problem: null}
}
export const clients = (state = clientsDefaults, action) => {
	switch (action.type) {
		case c.SET_CLIENTS_DATA:
			return {...clientsDefaults, data: action.response, createContractState: state.createContractState}
		case c.SET_CLIENT_DATA: {
			const data = {
				...action.response,
				contracts: undefined,
                contractIds: action.response.contracts && action.response.contracts.map(c => c.contractMain.contractId) || []
			}

			return {
				...state,
				clientData: {...state.clientData, [action.clientId]: data},
			}
		}
		case c.SET_CLIENT_SUB_MODULE: {
            const {name, subModuleZoom, createContractState} = action
			return {...state, subModule: name, subModuleZoom, createContractState}
        }
        case c.SET_CLIENT_CREATE_CONTRACT_STATE: {
            return {...state, createContractState: action.createContractState}
        }
        case c.SUBMENU_ITEM_ZOOMED:
            return {...state, submenuOpened: action.itemId, subModuleZoom: {},
                initialArguments: action.initialArguments
            }
        case c.HIDE_EMAIL_SENDER_MODAL: {
            return {...state,
                initialArguments: {
                    ...state.initialArguments,
                    // reset special initialisation values on close, to avoid
                    // to init the modal with the wrong values
                    startedFromModule: '',
                    autoSelectTemplate: false,
                    quickReply: false,
                    ticketId: '',
                }
            }
        }
		case c.FILTER_ITEMS:
			return {...state, filter: action.data}
		case c.FETCHED_CLIENT_FINANCES: {
			const finances = action.transactions.transactionDetails
			.map(t => (
				t.lineType === 'T' ? (
					{amount: t.amount, lineType: t.lineType}
				) : t
			))
			return {
				...state,
				finances: {
					...state.finances,
					[action.clientId]: finances,
				},
			}
		}
        case c.FETCHED_CLIENT_CLAIMS: {
            // collecting the claim related emails
            let claims = nesProp.get(action, "response.claims")
            let claimsManagersDetails = fetchClaimManagerDetails(claims)

            return {
				...state,
				claims: {
					...state.claims,
                    [action.clientId]: nesProp.get(action, "response.claims"),
                    claimsManagersDetails,
				},
            }
        }
		case c.CLIENT_DOC_UPDATE_BEM_COMMENT : {
			const { typeId: clientId, uploadId, bemComment } = action
			const clientDocuments = cloneDeep(state.clientData[clientId].clientDocuments) // clone documents to avoid mutation
			const clientDocumentIndex = clientDocuments.findIndex(d => d.clientDocumentId === uploadId)
			if (clientDocumentIndex !== -1) {
				const { commentKey, commentValue } = bemComment
				clientDocuments[clientDocumentIndex][commentKey] = commentValue
			}
			return {
				...state,
				clientData: {
					...state.clientData,
					[clientId]: {
						...state.clientData[clientId],
						clientDocuments,
					},
				},
			}
		}
		case c.CLAIM_DOCUMENT_DOC_UPDATE_BEM_COMMENT: {
			const { typeId: claimId, uploadId, bemComment, clientNumber } = action
			const claims = cloneDeep(state.claims[clientNumber]) // clone claims to avoid mutation
			const claimIndex = claims.findIndex(c => c.claimMain.claimId === claimId)
			if (claimIndex !== -1) {
				const claimDocuments = cloneDeep(claims[claimIndex].claimDocuments) // clone documents to avoid mutation
				const claimDocumentIndex = claimDocuments.findIndex(d => d.documentId === uploadId)
				if (claimDocumentIndex !== -1) {
					const { commentKey, commentValue } = bemComment
					claimDocuments[claimDocumentIndex][commentKey] = commentValue
					claims[claimIndex].claimDocuments = claimDocuments
				}
			}
			return {
				...state,
				claims: {
					...state.claims,
					[clientNumber]: claims,
				},
			}
		}
        case c.CLIENT_LOAD_CLAIMS_EXTRA: {
            let claimsExtraDetails = action.response
            // collecting the claim related emails
            let claims = nesProp.get(action, "response")
            let claimsManagersDetails = fetchClaimManagerDetails(claims)

            // if we have too many rows error we set only an empty array
            if (underscore.isArray(action.response) && action.response[0] === 'Too many rows') {
				claimsExtraDetails = []
            }

            return {
                ...state,
                claimsExtraDetails: claimsExtraDetails,
                claimsManagersDetails,
            }
        }
		case c.FETCHED_CLIENT_TARIFICATIONS: {
			try {
				let tarifications = action.tarifications
			return {
				...state,
				tarifications: {
					...state.tarifications,
					[action.clientId]: tarifications
				}
			}
			} catch (error) {
				console.warn(error);
			}
		}

		case c.LOGGED_OUT:
			return clientsDefaults
		default:
			return state
	}
}

const clientDefaults = {
	main: {},
	detail: {},
	clientDocuments: [],
	contracts: {},
	claims: [],
	tarificationDetail: {},
	filter: null,
}
export const client = (state = clientDefaults, action) => {
	switch (action.type) {
        case c.APP_CHANGED:
            return {
				...state,
				clientOptionsDict: action.clientOptionsDict || state.clientOptionsDict,
			}
        case c.SET_APP_MODULE:
            return {
				...state,
				clientOptionsDict: action.clientOptionsDict || state.clientOptionsDict, tarificationDetail: {},
			}
		case c.SET_CLIENT: {
			const data = action.response
			const contracts = {}

			for (const contract of data.contracts) {
				const {brancheCode} = contract.contractMain

				if (!(brancheCode in contracts)) {
					contracts[brancheCode] = []
				}

				contracts[brancheCode].push(contract.contractMain)
			}

			return {
				...state,
				...action.response,
				contracts,
			}
		}
		case c.SET_FILTER:
			return {
				...state,
				filter: state.filter === action.filter ? null : action.filter,
			}
		case c.SET_CONTRACT_DETAILS: {
			const result = {}

			for (const k of Object.keys(state.contracts)) {
				result[k] = state.contracts[k].map(c => {
					if (c.contractId === action.id) {
						return {
							...c,
							contractDetails: action.response.contractDetails,
							contractDocuments: action.response.contractDocuments,
							claims: action.response.claims,
						}
					}
					return c
				})
			}

			return {...state, contracts: result}
		}
		case c.SET_CLIENT_CLAIMS:
			return {...state, ...action.response}
		case c.SET_CLIENT_OPTIONS_DICT: {
			return {...state, clientOptionsDict: action.clientOptionsDict}
        }
        case c.SET_CLAIM_DETAIL: {
            return {
				...state,
				claimDetail: { ...action.response },
			}
        }
		case c.FETCHED_CLIENT_TARIFICATION_DATA: {
			return {
				...state,
				tarificationDetail: { ...action.response },
			}
		}
		case c.TARIFICATION_DOC_UPDATE_BEM_COMMENT: {
			const { uploadId: tarificationDocId, bemComment } = action
			const tarificationDocuments = cloneDeep(state.tarificationDetail.tarificationDocuments) // clone documents to avoid mutation
			const tarificationDocIndex = tarificationDocuments.findIndex(d => d.tarificationDocId === tarificationDocId)
			if (tarificationDocIndex !== -1) {
				const { commentKey, commentValue } = bemComment
				tarificationDocuments[tarificationDocIndex][commentKey] = commentValue
			}
			return {
				...state,
				tarificationDetail: {
					...state.tarificationDetail,
					tarificationDocuments,
				},
			}
		}
		case c.LOGGED_OUT:
			return clientDefaults
		default:
			return state
	}
}

const clientsFormDefaults = {
	type: null,
    clientData: {},
	clientId: null,
    selectedCheckboxes: {},
	existingClients: [],
	clientModal: false,
	formStatus: { isSending: false, sent: false, problem: null, emailDefault: false, phoneDefault: false}
}

export const clientProfileForm = ( state = clientsFormDefaults, action) => {
    switch (action.type) {
        case c.INITIALIZE_CLIENT_PROFILE_FORM: {
            state.type = action.formType

            if(action.formType == 'edit') {
                state.clientId      = action.clientId
                state.clientData    = action.clientData
            }

            return { ...state }
        }
        case c.CLEAN_CLIENT_PROFILE_FORM: {
            state = {
                type: null,
                clientData: {},
                clientId: null,
                selectedCheckboxes: {},
                existingClients: [],
				clientModal: false,
                formStatus: { isSending: false, sent: false, problem: null, emailDefault: false, phoneDefault: false}
            }

			return state
		}
		case c.FETCH_CLIENT_CLIENT_PROFILE_FORM: {
			state.clientData = action.response
			state.clientId = action.clientId
			state.type = 'edit'

			return state
		}
		case c.TOGGLE_LIST_DEFAULT_CLIENT_PROFILE_FORM: {
			if(action.listType == 'email')
			{
				state.formStatus.emailDefault = action.listValue
			}

			if(action.listType == 'phone')
			{
                state.formStatus.phoneDefault = action.listValue
			}
		}
		case c.FETCH_CLIENTS_CLIENT_PROFILE_FORM:
		{
			state.existingClients = action.response
			return { ...state }
		}
		case c.FETCH_RELATION_CLIENT_PROFILE_FORM:
		{
			state.existingClients = action.response
			return { ...state }
		}
		case c.TOGGLE_MODAL_CLIENT_PROFILE_FORM:
		{
			state.clientModal = action.modalStatus

			return state
		}
        case c.SET_PROFILE_FORM_CHECKBOX: {
            if (!state.selectedCheckboxes) {
                state.selectedCheckboxes = []
			}
			const index = action.id
            if (state.selectedCheckboxes[index]) {
                delete state.selectedCheckboxes[index]
            } else {
                state.selectedCheckboxes[index] = action.id
            }

            return {
                ...state,
            }
        }
        case c.CLEAN_PROFILE_FORM_CHECKBOX: {
            if(state.selectedCheckboxes)
            {
                state.selectedCheckboxes = [];
            }

            return {
                ...state
            }
        }
        case c.FORM_SUBMITTED: {
            state.formStatus.isSending = true
            return {...state}
        }
        case c.UPDATE_CLIENT_PROFILE_RESULT: {
            state.formStatus.isSending = false
            if (action.ok == true) {
                state.formStatus.sent = true
            }
            else
            {
            	state.formStatus.sent = true
                state.formStatus.problem = action.ok
            }

            return {...state}
		}
		case c.SENT_TO_FALSE_CLIENT_PROFILE_FORM: {
			let newState = { ... state }
			newState.formStatus.sent = false
			return { ... newState }
		}
		default:
			return state
    }
}

export const webapps = (state = [], action) => {
	switch (action.type) {
		case c.GOT_WEBAPPS:
			return action.response
		default:
			return state
	}
}

const defaultLang = (global.localStorage && global.localStorage.getItem('clientLanguage')) || 'nl'
const appDefaults = {
	module: isClient ? c.NEWS : null,
	menuCollapsed: false,
	subMenuCollapsed: true,
	loading: 0,
	backButton: null,
	lang: defaultLang,
    opened: null,
    claimsManagersDetails: null,
    backgroundProcessesDisabled: false,
	previousModule: null,
    versionCheckNotification: {msg: '', isOpened: false}
}
export const app = (state = appDefaults, action) => {
	switch (action.type) {
		case c.SET_IS_IE: {
			const {isIE} = action
			return {...state, isIE}
		}
		case c.APP_CHANGED:
			return {...state, ...action.data}
		case c.APP_PASSWORD_CHANGED:
			return {...state, "resetPassword": action.resetPassword || false}
		case c.SET_APP_MODULE: {
			const module = isClient ? (action.module || c.NEWS) : action.module
			return {...state, module, opened: action.id, previousModule: null}
		}
		case c.NAVIGATE_TO_DSDOCUMENT: {
			const module = action.module
			return {...state, module, opened: action.id, previousModule: action.currentModule}
		}
		case c.TOGGLE_MENU: {
			const menuCollapsed = action.state == null ? !state.menuCollapsed : Boolean(action.state)
			return {...state, menuCollapsed}
		}
		case c.TOGGLE_SUB_MENU: {
			const subMenuCollapsed = action.state == null ? !state.subMenuCollapsed : Boolean(action.state)
			return {...state, subMenuCollapsed, brokers: action.brokers}
		}
		case c.MEDIA_CHANGED: {
			const {isPhone} = action.data
			if (isPhone != null) {
				return {...state, menuCollapsed: isPhone}
			}
			return state
		}
		case c.LOGGED_OUT:
			return appDefaults
		case c.SHOW_LOADER:
			return {...state, loading: (state.loading + 1)}
		case c.HIDE_LOADER:
			return {...state, loading: (state.loading - 1)}
        case c.FORCE_SET_LOADER:
			return {...state, loading: action.loaderValue*1}
		case c.ITEM_ZOOMED:
			return {...state, opened: action.itemId}
		case c.SUBMENU_ITEM_ZOOMED:
			return {...state, submenuOpened: action.itemId}
		case c.BRNR_USED:
			return {...state, brNr: action.brNr}
		case c.LANG_SET:
			return {...state, lang: action.lang}
		case c.NOTIFICATION_SET: {
			const {msg, nType} = action
			return {...state, notification: {msg, nType}}
		}
        case c.VERSION_CHECK_NOTIFICATION_SET: {
			const {isOpened, msg, title} = action
			return {...state, versionCheckNotification: {msg, isOpened, title}}
		}

		case c.NOTIFICATION_CLEAR: {
			return {...state, notification: null}
        }

        // TODO claims extra data extracted here because the claims store hierarchy is an array.
        // Can not add other properties to the module reducer. Todo is to encapsulate the claims
        // array in to a property of an object to be able store other data related the claims module
        // in the own section.
        // Here the app subscribed to the SET_CLAIMS_DATA action. When you solve this todo you have to
        // remove this.
        case c.SET_CLAIMS_DATA: {
            let claimsManagersDetails = fetchClaimManagerDetails(action.response)
            return {
                ...state,
                claimsManagersDetails: claimsManagersDetails
            }
        }

        case c.SHOW_PRINT_MODAL: {
            let additionalObject = {}
            let modalId = action && action.modalId || ""

            nesProp.set(additionalObject, modalId+"IsOpen", true)
            nesProp.set(additionalObject, "modalId", modalId)

            return {...state,
                printModal: {...action.printModal, ...additionalObject}
            }
        }

        case c.HIDE_PRINT_MODAL: {
            let additionalObject = {}
            let modalId = action && action.modalId || ""

            nesProp.set(additionalObject, modalId+"IsOpen", false)

            return {...state,
                printModal: {
                    message: '-',
                    title: '-',
                    flag: nesProp.get(state, "printModal.flag") || "",
                    result: action.result,
                    ...additionalObject,
                }}
        }
        case c.DISABLE_BACKGROUND_PROCESSES:
			return {...state, backgroundProcessesDisabled: action.backgroundProcessesDisabled}

		default:
			return state
	}
}

/*********************************************
 * Email sender module
 ********************************************/
const emailSenderDefaults = {
    emailModalIsOpen: false,
    emailSentModalIsOpen: false,
    emailNotSentModalIsOpen: false,
    emailConfModalIsOpen: false,
    waitingModalIsOpen: false,
    showPreviewModal: false,
	emailServerConfigModalIsOpen: false,
	serverConfigIsSaved: false,
	senderEmailAddress:'',
    moduleKey: '',
	modalIdOpened: ''
}

export const emailSender = (state = emailSenderDefaults, action) => {
	switch (action.type) {
        case c.SET_APP_MODULE: {
            return {
                ...emailSenderDefaults,
                externalAttachments: state && state.externalAttachments || []
            }
        }
        // preset the module where will be opened
        case c.SET_EMAIL_SENDER_MODULE: {
            return {
                ...state,
                moduleKey: action.moduleKey,
                modalIdOpened: action.modalId,
            }
		}
        // pop up the modal (optionally with ID)
        case c.SHOW_EMAIL_SENDER_MODAL: {
            return {...state,
                emailModalIsOpen: true,
                // moduleKey: state.moduleKey
            }
		}
		case c.HIDE_EMAIL_SENDER_MODAL:{
            return {
                ...state,
                emailModalIsOpen: false,
                modalIdOpened: '',
				moduleKey: ''
            }
		}
        case c.SHOW_EMAIL_SENDER_CONF_MODAL: {
            let additionalObject = {}
            // decide witch modal can be handled
            let modalId = action && action.modalId || ""
            switch(modalId) {
                case "emailSentModal": {
                    additionalObject.emailSentModalIsOpen = true
                    break;
                }
                case "emailNotSentModal": {
                    additionalObject.emailNotSentModalIsOpen = true
                    break;
                }
                case "emailConfModal": {
                    additionalObject.emailConfModalIsOpen = true
                    break;
                }
                case "waitingModal": {
                    additionalObject.waitingModalIsOpen = true
                    break;
                }
                case "previewModal": {
                    additionalObject.showPreviewModal = true
                    break;
                }
            }
            return {...state,
                ...additionalObject,
				serverConfigIsSaved: false,
                confirmationModal: action.confirmationModal
            }
        }
		case c.SHOW_EMAIL_SERVER_CONFIG_MODAL:
			return  {...state, emailServerConfigModalIsOpen: true, senderEmailAddress: action.senderEmailAddress}
		case c.HIDE_EMAIL_SERVER_CONFIG_MODAL:
			return  {...state, emailServerConfigModalIsOpen: false, serverConfigIsSaved: action.serverConfigIsSaved, senderEmailAddress: ''}
        case c.HIDE_EMAIL_SENDER_CONF_MODAL: {
            let additionalObject = {}
            // decide witch modal can be handled
            let modalId = action && action.modalId || ""
            switch(modalId) {
                case "emailSentModal": {
                    additionalObject.emailSentModalIsOpen = false
                    break;
                }
                case "emailNotSentModal": {
                    additionalObject.emailNotSentModalIsOpen = false
                    break;
                }
                case "emailConfModal": {
                    additionalObject.emailConfModalIsOpen = false
                    break;
                }
                case "waitingModal": {
                    additionalObject.waitingModalIsOpen = false
                    break;
                }
                case "previewModal": {
                    additionalObject.showPreviewModal = false
                    break;
                }
            }
            return {...state,
                ...additionalObject,
                confirmationModal: {
                message: '-',
                title: '-',
                flag: nesProp.get(state, "confirmationModal.flag") || "",
                result: action.result,
            }}
        }
        case c.SHOW_EMAIL_SENDER_ATT_MODAL: {
            return {...state,
                emailAttModalIsOpen: true,
                attachmentModal: action.attachmentModal
            }
        }
        case c.HIDE_EMAIL_SENDER_ATT_MODAL: {
            return {...state, emailAttModalIsOpen: false, attachmentModal: {
                message: '-',
                title: '-',
                flag: nesProp.get(state, "attachmentModal.flag") || "",
                result: action.result,
            }}
        }
        case c.SET_EMAIL_EXTERNAL_ATTACHMENTS: {
            return {...state,
                externalAttachments: action.externalAttachments
            }
        }
        /* case c.EMAIL_SENDER_UPDATE_MODULE_OPTIONS: {
            return {...state, moduleOptions: {...state.moduleOptions, ...action.moduleOptions}}
        } */
        /* case c.INIT_EMAIL_SENDER_FORM: {
            state = {
                emailLangField: 'nl',
                formStatus: { isSending: false, sent: false, problem: null}
            }

            return state
        } */
        case c.SET_CLAIMS_DATA: {
            let claimsManagersDetails = fetchClaimManagerDetails(action.response)
            return {...state,
                claimsManagersDetails: claimsManagersDetails
            }
        }
        default:
            return state
    }
}
export const emailDocument = (state = {_gen: 0}, action) => {
	switch (action.type) {
		case c.SET_EMAIL_DOCUMENT_ID: {
            return {...state, id: action.id}
        }
		default:
			return state
	}
}


/*********************************************
 * END Email sender module
 ********************************************/

export const dict = (state = {_gen: 0}, action) => {
	switch (action.type) {
		case c.GOT_TRANSLATIONS: {
			const dict = {}
			for (const item of action.dict) {
				dict[item.key] = item.t
			}
			dict._gen = state._gen + 1
			return dict
		}
		default:
			return state
	}
}

const areCookies = global.localStorage && global.localStorage.getItem('cookiesAccepted')
const authDefaults = {
    isLoggedIn: false,
    authState: "",
    options: {},
    errors: null,
    cookiesAccepted: areCookies,
    password: null,
    confirmation: {
        hash: null,
        step: 1,
        isSending: false
    }
}

export const auth = (state = authDefaults, action) => {
	switch (action.type) {
		case c.LOG_IN:
			return {...state, isLoggedIn: true}
		case c.BAD_CREDENTIALS:
            if(state.authState !== 'accountConfirmation'){
                return {...state, authState: "", isLoggedIn: false}
            }
            break
		case c.AUTH_STATE_CHANGED:
			return {...state, authState: action.authState, options: action.options, errors: null}
		case c.HAS_ERRORS:
			return {...state, errors: {id: action.id}}
		case c.LOGGED_OUT:
			const cookieData = Cookies && ( Cookies.get('cookiesAccepted') !== undefined) ? Cookies.get('cookiesAccepted') : null;
			return {
				...authDefaults,
				cookiesAccepted: cookieData
			}
		case c.COOKIES_ACCEPTED:
			return {...state, cookiesAccepted: true}
		case c.COOKIES_CLEAN:
			Cookies.remove('cookiesAccepted')
			return {...state, cookiesAccepted: false}
		case c.SET_PASSWORD:
            return {...state, password: action.password}
        case c.SET_ACCOUNT_CONFIRMATION_HASH: {
            return {
                ...state,
                confirmation: {
                    ...state.confirmation,
                    hash: action.payload
                }
            }
        }
		case c.SET_ACCOUNT_CONFIRMATION_STEP: {
			return {
				...state,
				confirmation: {
					...state.confirmation,
					step: action.payload
				}
			}
        }
		case c.CLEAN_ACCOUNT_CONFIRMATION: {
			return {
				...state,
				confirmation: authDefaults.confirmation
			}
		}
		default:
			return state
	}
}

export function responsive(state = {}, action) {
	switch (action.type) {
		case c.MEDIA_CHANGED:
			return {...state, ...action.data}
		default:
			return state
	}
}

const b2bDefaults = {
	b2bInsuranceCompany: {companyId: false, insuranceCompany: ''}
}

export const b2b = (state = b2bDefaults, action) => {
	switch (action.type) {
		case c.SET_APP_MODULE: // reset
			return {...b2bDefaults, b2bInsuranceCompany: state.b2bInsuranceCompany}
		case c.SET_B2B_INSURANCE_COMPANY:
			return {...state, b2bInsuranceCompany: action.b2bInsuranceCompany}
		case c.B2BCOMPANY_SEARCH_BY_CONTRACT_NUMBER:
			return {...state, isByContractNumber: action.isByContractNumber}
		case c.LOGGED_OUT:
			return b2bDefaults
		default:
			return state
	}
}

const b2bCompanyDefaults = {
	brNr: "",
	menuCollapsed: false,
	subMenuCollapsed: true,
	loading: 0,
	backButton: null,
	lang: defaultLang,
	opened: null,
	policyActions: {},
	policySubActions: {},
	currentClientAction: "",
	currentClientSubAction: "",
	brokers: {},
	b2bCompanyCompany: {},
	B2BTransactions: [],

	data: null,
	clientData: {},
	subModule: "",
	finances: {},
	subModuleZoom: {},
	filter: {},

	policy: null,
	policyModal: {visible: false, policyId: null}
}

export const b2bCompany = (state = b2bCompanyDefaults, action) => {
	switch (action.type) {
		case c.SET_APP_MODULE: // reset
			return {...b2bCompanyDefaults, data: b2bCompanyDefaults.data, brokers: state.brokers || {}, brNr: state.brNr || ""}
		case c.SET_B2BCOMPANY_CLIENTS_DATA:
			return {...state, data: action.response, brNr: state.brNr}
		case c.SET_B2BCOMPANY_SUB_MODULE: {
			const {name, subModuleZoom} = action
			return {...state, subModule: name, subModuleZoom}
		}
		case c.B2BCOMPANY_ITEM_ZOOMED:
			return {...state, opened: action.itemId}
		case c.B2BCOMPANY_BRNR_USED:
			return {...state, brNr: action.brNr}
		case c.SET_B2BCOMPANY_SELECTED_POLICY:
			return {...state, selectedPolicy: action.selectedPolicy}
		case c.B2BCOMPANY_CLIENT_ACTION_USED:
			return {...state, currentClientAction: action.currentClientAction}
		case c.B2BCOMPANY_CLIENT_SUB_ACTION_USED:
			return {...state, currentClientSubAction: action.currentClientSubAction}
		case c.SET_B2BCOMPANY_BROKERS_DATA:
			return {...state, brokers: action.brokers, accountManagers: action.accountManagers}

		case c.B2BCOMPANY_SET_ACTIONS_DICT:
			return {...state, b2bCompanyActionsDict: action.b2bCompanyActionsDict}
		case c.B2BCOMPANY_GET_ACTIONS:
			return {...state, policyActions: action.policyActions, policySubActions: action.policySubActions}
		case c.B2BCOMPANY_SWITCH_ACTION:
			return {...state, policySubActions: action.policySubActions}
		case c.B2BCOMPANY_SET_TRANSACTION_DETAILS:
			return {...state, transactionDetails: action.transactionDetails}
		case c.B2BCOMPANY_SET_COMPANY:
			return {...state, b2bCompanyCompany: action.b2bCompanyCompany}
		case c.B2BCOMPANY_SET_TRANSACTIONS:
			return {...state, B2BTransactions: action.B2BTransactions}

		case c.SET_CLIENT_DATA: {
            const data = {
				...action.response,
				contracts: undefined,
				contractIds: action.response.contracts && action.response.contracts.map(c => c.contractMain.contractId) || [],
			}

			return {
				...state,
				clientData: {...state.clientData, [action.clientId]: data},
			}
		}
		case c.B2BCOMPANY_FETCHED_POLICIES:
			return {...state, policies: action.policies}
		case c.SHOW_B2BCOMPANY_POLICY_MODAL:
			return {...state, policyModal: {visible: true, policyId: action.id}}
		case c.HIDE_B2BCOMPANY_POLICY_MODAL:
			return {...state, policyModal: {visible: false, policyId: null}}
		case c.LOGGED_OUT:
			return b2bCompanyDefaults
		default:
			return state
	}
}

const notificationsDefault = {
	items: []
}

export const notifications = (state = notificationsDefault, action) => {
	switch (action.type) {
		case c.SET_APP_NOTIFICATIONS:
			if(action.response && action.response.length) {
				const items = []

				action.response.map((value,key) => {
					const item = {
						title: value.title,
						messageNl: value.message,
						messageEn: value.messageEn,
						messageFr: value.messageFr,
						showBroker: value.showBroker,
						showClient: value.showClient,
						expires: value.expires
					}

					items[key] = item
				})

				state.items = items
			}
			return {...state}
		default:
			return state
	}
}

const taskCreatorDefault = {
    modalIsOpen: false,
    error: null,
    statusText: null,
}

/** Task creator
 ****************************************************************************************/
export const taskCreator = (state = taskCreatorDefault, action) => {
	switch(action.type) {
		case c.TASK_CREATOR_MODAL_TOGGLE:
			return {
				...state,
				modalIsOpen: !state.modalIsOpen,
                error: null,
                statusText: null
			}

        case c.TASK_CREATOR_CONVERTION_SUCCESS:
			return {
                ...state,
                modalIsOpen: false,
                error: null,
                statusText: null
            }

        case c.TASK_CREATOR_CONVERTION_FAIL:
            let message = 'Something went wrong please try again later'
            let statusText = 'Something went wrong please try again later'

            if(action.err && action.err.message) {
                message = action.err.message
            }

            if(action.err && action.err.statusText) {
                statusText = action.err.statusText
            }

			return {
                ...state,
                error: message,
                statusText: statusText
            }

		default:
			return state
	}
}

/**************************************************
 * ****  Digitally Signed Documents ***************
 **************************************************/

/**
 * This function filter items by status, important the statuses must be organised in time order correctly on server
 * What provide the status list here, to be able to decide, we are after or before.
 * @param {*} fn
 * @param {*} DSDocumentOriginTypes
 */
const DSDocFilters = (fn, DSDocumentOriginTypes) => {
    switch(fn) {
        case "showDraft":
            return (item) => {
                return (item.package.status === c.DS_FILLED_BY_BROKER)
            }
        break
        case "showSigned":
			return (item) => {
				const dsDocument = item.dsDocument
				const templates = item.templates
				let documentTemplateId = nesProp.get(dsDocument, "documentTemplateId")
				let docTemplateArray = templates && templates.filter(
						(oneTemplate) => (String(oneTemplate._id) === String(documentTemplateId))
					) || false

				let documentTemplate = docTemplateArray && docTemplateArray[0] || false
				let mustBeSigned = isDocumentMustBeSigned(DSDocumentOriginTypes, dsDocument.origin, documentTemplate)
				let signedIndex = -1;

				if (dsDocument.package.statusHistory) {
					dsDocument.package.statusHistory.forEach((oneStatus, index)=>{
						if (oneStatus.status === c.DS_PACKAGE_STATUS_FINISHED && mustBeSigned) {
							signedIndex = index
						}
					})
				}

				return signedIndex !== -1
			}
        break
        case "showNotSigned":
            return (item) => {
                const dsDocument = item.dsDocument
				const templates = item.templates
                let documentTemplateId = nesProp.get(dsDocument, "documentTemplateId")
                let docTemplateArray = templates && templates.filter(
                        (oneTemplate) => (String(oneTemplate._id) === String(documentTemplateId))
                    ) || false

                let documentTemplate = docTemplateArray && docTemplateArray[0] || false
                let mustBeSigned = isDocumentMustBeSigned(DSDocumentOriginTypes, dsDocument.origin, documentTemplate)

                let signedIndex = -1;
                if (dsDocument.package.statusHistory) {
                    dsDocument.package.statusHistory.forEach((oneStatus, index)=>{
                        if (oneStatus.status === c.DS_PACKAGE_STATUS_FINISHED) {
                            signedIndex = index
                        }
                    })
                }

                // if package is signed but this is a document what does not require signature than to be listed
                // ASKED TO HIDE THIS EVEN IN THIS CASE: BEWB-408
                if (!mustBeSigned) {
                    signedIndex = 1
                }

                return signedIndex == -1
            }
        break
        case "showAll":
            return (item) => {
                return true
            }
		case "showNotLinked" :
			return (item) => {
				try {
					const dsDocument = item.dsDocument
					const templates = item.templates

					// collecting the logical values for determination of result
					let documentTemplateId = nesProp.get(dsDocument, "documentTemplateId")
        			let docTemplateArray = templates && templates.filter(
                			(oneTemplate) => (String(oneTemplate._id) === String(documentTemplateId))
            			) || false

					let documentTemplate = docTemplateArray && docTemplateArray[0] || false
					let mustBeSigned = isDocumentMustBeSigned(DSDocumentOriginTypes, dsDocument.origin, documentTemplate)
					let isSigned = documentIsSigned(dsDocument)
					let packageIsEditable = (dsDocument.package.isEditable === false) ? false : true

					// determine the result
					return (!dsDocument.uploadedToOracle && checkIfShouldLinkWithContract(dsDocument) &&
					!packageIsEditable)? true : false

				} catch (error) {
				  	console.warn(error)
				}
			}
        break
    }
}

const checkIfShouldLinkWithContract = (dsDocument) => {
	// if document is uploaded to oracle or doc is falsy return false
	if(!dsDocument || dsDocument.uploadedToOracle) {
		return false
	}

	let contractIdIsRequired = nesProp.get(dsDocument, 'documentTemplate.uploadedOnModule') === c.DS_MODULE_CLIENT_CONTRACT
	if(!contractIdIsRequired) {
		return false
	}

    let hasContractId = nesProp.get(dsDocument, "contractId")

	//determine the result
	return (contractIdIsRequired && !hasContractId)
}

const documentIsSigned = (dsDocument) => {
    let isSigned = false

    if (dsDocument && dsDocument.package.statusHistory) {
        dsDocument.package.statusHistory.forEach((oneStatus) => {
            if (oneStatus.status === c.DS_PACKAGE_STATUS_FINISHED) {
                isSigned = true
            }
        })
    }
    return isSigned
}

/**
 * This function returns true if the item could be shown by date filters, else return the original visibility value.
 * @param {*} item
 * @param {*} startDate
 * @param {*} endDate
 */
const DSShouldShowByDates = (item, startDate, endDate) => {
    let should = !item.hidden

    let mStartDate = moment(moment(startDate).format("DD-MM-YYYY"), "DD-MM-YYYY")
    let mEndDate = moment(moment(endDate).format("DD-MM-YYYY"), "DD-MM-YYYY")

    const createdAt = moment(moment(item.createdAt).format("DD-MM-YYYY"), "DD-MM-YYYY")

    if(startDate && mStartDate.isValid()) {
        should = should && (!mStartDate.isAfter(createdAt) || mStartDate.isSame(createdAt))
    }
    if(endDate && mEndDate.isValid()) {
        should = should && (mEndDate.isAfter(createdAt) || mEndDate.isSame(createdAt))
    }

    return should
}

/**
 * This function provide the number of draft documents in the list.
 * @param {array} items
 */
const calcDocDraft = (items) => items && items.reduce(
    (a, i) =>
        a + ((i.status == 'draft') ? 1 : 1) // TODO implement it correctly
    , 0) || []

/**
 * This function will set the visibility information for elements in the doc list, and format-extend the values for data table
 * @param {*} items
 * @param {*} state
 */
const DSDocumentItemsFormatter = (items, filterFunctionName, DSDocumentOriginTypes, startDate, endDate) => {
    const shouldShow = DSDocFilters(filterFunctionName, DSDocumentOriginTypes)

	let result = []
	//check if the sort condition is "showNotLinked" this procedure requires also the template list
	if(filterFunctionName && (
        filterFunctionName === 'showNotLinked' ||
        filterFunctionName === 'showSigned' ||
        filterFunctionName === 'showNotSigned')
    )
	{
		result = items.dsDocuments
    	.map(item => {
    	    return {
    	        ...item,
    	        id: item._id,
    	        hidden: !shouldShow({dsDocument: item, templates: items.templates})
    	    }
    	})
    	.map(item => {
    	    return {
    	        ...item,
    	        hidden: !DSShouldShowByDates(item, startDate, endDate)
    	    }
    	})
	} else {
		result = items
    	.map(item => {
    	    return {
    	        ...item,
    	        id: item._id,
    	        hidden: !shouldShow(item),
    	    }
    	})
    	.map(item => {
    	    return {
    	        ...item,
    	        hidden: !DSShouldShowByDates(item, startDate, endDate)
    	    }
    	})
	}

    return result
}

/**
 * This function extend the documents with package records
 * @param {*} packages
 * @param {*} documents
 * @param {*} templates
 */
const DSPackageMergeToDoc = (packages, documents, templates) => {
    if (!documents || documents.length === 0) {
        return documents
    }

    let packageMap = {}
    packages && packages.forEach((onePackage)=>{
        nesProp.set(packageMap, onePackage._id, onePackage)
    })

    let templateMap = {}
    templates && templates.forEach((oneTemplate)=>{
        nesProp.set(templateMap, oneTemplate._id, oneTemplate)
    })

    // extend the documents with the package records
    documents = documents && documents.map((oneDoc)=>{
        // find the index of package
        return {
            ...oneDoc,
            documentTemplate: nesProp.get(templateMap, oneDoc.documentTemplateId) || {_id: oneDoc.documentTemplateId},
            package: nesProp.get(packageMap, oneDoc.packageId) || {_id: oneDoc.packageId}
        }
    })

    return documents
}

// initial values for module
const DSDocumentsDefaults = {items: [], paginatedPackages: [], totalPackageRecords: 0, sortParams: {column: 'createdAt',
	sortOrder: -1}, pageNumber: 0, filter: '', DSDocumentsFailedCount: 0, selectValue: 'showAll', subModule: '',
    opened: '', startDate: null, endDate: null, config: {}, DSWizardOpened: false, forceOpenInvitationEditor: false,
    moduleKey: '', client: null, packages: [] ,templates: [], preSortDocumentsFromClient: null, subgroups: [],
    openedPackage: '', DSDocumentOriginTypes: {}, forceOpenInvitationFromTicket: false, openedMifidKey: null}

/**
 * Reducer for DSDocuments module
 * @param {*} state
 * @param {*} action
 */
export const DSDocuments = (state = DSDocumentsDefaults, action) => {
    switch (action.type) {
        case c.APP_CHANGED:
			return {...state, DSDocumentOriginTypes: action.data.security.DigitalSignatureHardLists.DSDocumentOriginTypes}
        case c.SET_APP_MODULE: // reset some values
            return {
                ...state,
                subModule: action.subModule || DSDocumentsDefaults.subModule,
                opened: action.opened || DSDocumentsDefaults.opened,
				openedPackage: action.openedPackage || DSDocumentsDefaults.openedPackage,
                selectValue: action.selectValue || DSDocumentsDefaults.selectValue,
				preSortDocumentsFromClient: action.preSortDocumentsFromClient || null,
            }
		case c.NAVIGATE_TO_DSDOCUMENT:
			return {
                ...state,
                subModule: action.subModule || DSDocumentsDefaults.subModule,
                opened: action.itemId || DSDocumentsDefaults.opened,
                selectValue: action.selectValue || DSDocumentsDefaults.selectValue
            }
        case c.GOT_DS_CONFIG: {
            return {
                ...state,
                config: action.config
            }
        }
        case c.GOT_DSDOCUMENTS: {
            // fill up documents with packages
            let items = DSPackageMergeToDoc(
                state.packages,
                items,
                state.templates
            )

            items = DSDocumentItemsFormatter(
                action.data,
                state.selectValue || DSDocumentsDefaults.selectValue,
                state.DSDocumentOriginTypes,
                state.startDate,
                state.endDate
            ) || []



            return {
                ...state,
                items,
                DSDocumentsFailedCount: calcDocDraft(items),
                ts: action.ts,
            }
        }
        case c.GOT_DSPACKAGES: {
            // fill up documents with packages
            let items = DSPackageMergeToDoc(
                action.data,
                state.items,
                state.templates
            )

            return {
                ...state,
                packages: action.data,
                items,
                DSDocumentsFailedCount: calcDocDraft(items),
            }
        }
        case c.GOT_DSDOCS_AND_PACKAGES: {
            let docs = nesProp.get(action, "data.dsdocuments")
			let packages = nesProp.get(action, "data.packages")
            let templates = nesProp.get(action, "data.templates")

			let items = DSPackageMergeToDoc(
                packages,
                docs,
                templates
            )

            items = DSDocumentItemsFormatter(
                items,
                state.selectValue,
                state.DSDocumentOriginTypes,
                state.startDate,
                state.endDate
            ) || []

			return {
                ...state,
                packages,
                templates,
                items,
                DSDocumentsFailedCount: calcDocDraft(items),
            }
        }
		case c.GOT_PAGINATED_PACKAGES:
			const {paginatedPackages, totalPackageRecords, paginationData} = action.data
			return {
				...state,
				paginatedPackages,
				totalPackageRecords,
				sortParams: paginationData.sortParams,
				pageNumber: paginationData.pageNumber,
				filter: paginationData.filter,
				selectValue: paginationData.filterFunction,
				startDate: paginationData.startDate,
				endDate: paginationData.endDate,
			}

		case c.RESET_PAGINATED_DATA:
			return {
				...state,
				paginatedPackages: [], totalPackageRecords: 0, sortParams: {column: 'createdAt', sortOrder: -1},
				pageNumber: 0, filter: '', selectValue: 'showAll'
			}

		case c.GOT_DSDOCUMENT: {
            // PATCH the new dsdocument record to the big list ot avoid the full fetch from the server
            let items = state.items.map(item => {

                if (item._id == action.dsdocument._id) {
                    item = { ...item, ...action.dsdocument}
                }

                return item
            })

            // overview filtering again because updated values
            items = DSDocumentItemsFormatter(
                items,
                state.selectValue || DSDocumentsDefaults.selectValue,
                state.DSDocumentOriginTypes,
                state.startDate,
                state.endDate
            ) || (() => true)

            // push values back to the store, recalc draft items also
            return {
                ...state,
                items,
                DSDocumentsFailedCount: calcDocDraft(items)
            }
        }
        case c.SET_DSDOCUMENT_SUB_MODULE: {
			const {name, subModuleZoom} = action
			return {...state, subModule: name, subModuleZoom}
		}
		case c.DSDOCUMENT_ITEM_ZOOMED:
			return {...state, opened: action.itemId}
		case c.DSDOCUMENT_PACKAGE_ZOOMED:
			return {...state, openedPackage: action.packageId}
        case c.TICKETS_FILTERED:
            return {...state, filter: (action.filter || '')}
        case c.DSDOCUMENT_SET_FILTERED: {
            const {selectValue, startDate, endDate} = action

            let finalSelectValue = selectValue || state.selectValue
            let finalStartDate = (startDate ? startDate : null)
            let finalEndDate =  (endDate ? endDate : null)
			let itemsToSort = {dsDocuments : state.items}

			//check if the sort condition is "showNotLinked" this procedure requires also the template list
			if(finalSelectValue && (
                finalSelectValue === 'showNotLinked' ||
                finalSelectValue === 'showSigned' ||
                finalSelectValue === 'showNotSigned'
            )) {
				itemsToSort = {
					dsDocuments: state.items,
					templates: state.templates
				}
			}

            let items = DSDocumentItemsFormatter(
                itemsToSort,
                finalSelectValue,
                state.DSDocumentOriginTypes,
                finalStartDate,
                finalEndDate
            ) || (() => true)

            return {
                ...state,
                items: items,
                selectValue: finalSelectValue,
                startDate: finalStartDate,
                endDate:  finalEndDate,
				preSortDocumentsFromClient: null
            }
        }
        case c.SET_ALL_VISIBLE_CHECKED: {
			return {...state, paginatedPackages: state.paginatedPackages.map(onePackage => {
				onePackage.checked = onePackage.checked? false : true
				return onePackage
			})}
            // const items = action.visibleItems
            // const vI = items.length
            // const cI = state.items.reduce(
            //     (acc, item) => acc + (item.checked && items.includes(item.id) ? 1 : 0),
            //     0
            // )
            // const toCheck = vI !== cI

            // return {...state, items: state.items.map(item => ({...item, checked: items.includes(item.id) ? toCheck : item.checked}))}
        }
        case c.SET_ALL_CHECKED: {
            return {...state, paginatedPackages: state.paginatedPackages && state.paginatedPackages.map(onePackage => ({...onePackage, checked: true})) || []}
        }
        case c.SET_CHECKBOX:
            return {...state, paginatedPackages: state.paginatedPackages.map(onePackage =>
                ({...onePackage, checked: onePackage.id === action.id ? !onePackage.checked : onePackage.checked})
            )}
        case c.LOGGED_OUT:
            return DSDocumentsDefaults
        case c.DSDOCUMENT_ITEMS_STATUS: {
            const {emailIds, status: {archived}} = action
            const newItems = state.items.map(i => {
                if (emailIds.includes(i.id)) {
                    return {
                        ...i,
                        archived: archived == null ? i.archived : archived,
                    }
                }
                return i
            })
            return {
                ...state,
                items: newItems
            }
        }
        case c.SET_DS_WIZARD: {
            return {
                ...state,
                DSWizardOpened: action.DSWizardOpened,
                moduleKey: action.moduleKey,
				openedMifidKey: action.mifidKey
            }
        }
        case c.SET_DS_INVITATION_EDITOR: {
            return {
                ...state,
                forceOpenInvitationEditor: action.forceOpenInvitationEditor,
                moduleKey: action.moduleKey
            }
        }
        case c.SET_DS_INVITATION_EDITOR_FROM_TICKET: {
            return {
                ...state,
                forceOpenInvitationFromTicket: action.forceOpenInvitationFromTicket,
                moduleKey: action.moduleKey
            }
        }
        case c.SET_CLIENT_DATA: {
            return {
                ...state,
                client: {
                    ...action.response,
                    clientId: action.clientId,
                    clientNumber: action.clientNumber
                },
            }
        }
        case c.GOT_DSDOCUMENT_TEMPLATE: {
            return {
                ...state,
                templates: action.data
            }
        }
        case c.GOT_DSDATASET: {
            return {
                ...state,
                DSDataSets: action.data
            }
        }
        case c.GOT_TEAM_SUBGROUPS: {
            return {
                ...state,
                subgroups: action.data
            }
        }
        default:
            return state
    }
}

/**************************************************
 * **** END OF  Digitally Signed Documents ********
 **************************************************/

// initial values for module
const usersProcessFlagDefaults = {}

/**
 * Reducer for DSDocuments module
 * @param {*} state
 * @param {*} action
 */
export const UsersProcessFlag = (state = usersProcessFlagDefaults, action) => {
    switch (action.type) {
        // update the users process record in store
        case c.USERS_PROCESS_FLAG_ARRIVED: {

            if (!action.referenceId) {
                throw new Error("Missing referenceId for watching users process flag.")
            }

            let referenceId = action.referenceId || "unknownReference" // if there is no reference that is an error
            let record = action.record
            let isActive = nesProp.get(state, referenceId+".isActive") || false
            let checkpointCount = nesProp.get(state, referenceId+".checkpointCount") || 1

            return {
                ...state,
                [referenceId]: {
                    record, // update the users process flag record arrived from server
                    isActive, // this must be unchanged here
                    checkpointCount // this must be unchanged here
                }
            }
        }

        // stop watching the users process record from server
        case c.USERS_PROCESS_FLAG_STOP_WATCH: {

            if (!action.referenceId) {
                throw new Error("Missing referenceId for watching users process flag.")
            }

            let referenceId = action.referenceId || "unknownReference" // if there is no reference that is an error
            let record = nesProp.get(state, referenceId+".record")
            let checkpointCount = nesProp.get(state, referenceId+".checkpointCount") || 1

            return {
                ...state,
                [referenceId]: {
                    record,  // this must be unchanged here
                    checkpointCount,  // this must be unchanged here
                    isActive: false // deactivate the watching of the server
                }
            }
        }

        // start watching the users process record from server
        case c.USERS_PROCESS_FLAG_START_WATCH: {

            if (!action.referenceId) {
                throw new Error("Missing referenceId for watching users process flag.")
            }

            let referenceId = action.referenceId || "unknownReference" // if there is no reference that is an error
            let checkpointCount = action.checkpointCount || 1// if there is no reference that is an error
            let record = nesProp.get(state, referenceId+".record")

            return {
                ...state,
                [referenceId]: {
                    record,  // this must be unchanged here
                    isActive: true, // deactivate the watching of the server
                    checkpointCount // count of elements to show the dots in the progress line
                }
            }
        }

        // remove a users process flag reference from store.
        case c.USERS_PROCESS_FLAG_REMOVE: {
            if (!action.referenceId) {
                return console.error("Missing referenceId for clear users process flag.")
            }

            let referenceId = action.referenceId || "unknownReference" // if there is no reference that is an error
            let newState = state

            // remove the specified reference from store
            if (newState && newState[referenceId]) {
                delete newState[referenceId]
            }

            // apply new state for store
            return newState
        }

        default:
            return state
    }
}

/**
 * This function determine if a document must be signed.
 * This function will be obsolete here, when the client side dsdocument filtering will be removed.
 * @param {object} DSDocumentOriginTypes
 * @param {string} origin
 * @param {object} documentTemplate
 * @returns
 */
const isDocumentMustBeSigned = (DSDocumentOriginTypes, origin, documentTemplate=null) => {
    if (!DSDocumentOriginTypes) {
        return null
    }

    switch (origin) {
        case DSDocumentOriginTypes.DS_ORIGIN_LOCAL_UPLOAD: {
            return true
            break
        }
        case DSDocumentOriginTypes.DS_ORIGIN_ORACLE:  {
            return true
            break
        }
        case DSDocumentOriginTypes.DS_ORIGIN_GENERATED:
        default: {
            return !!documentTemplate.mustBeSigned
        }
    }
}

// Version 10
const claimWizardDefaults = {
	wizardStep: '1', claimData: {}, isLegalAid: false, documents: [], involvedParties: [], optionalParties: [], involvedPartiesData: [],
	dsDocumentTemplates: [], documentFiles: [], claimWizardPackages: [], dsPackages: {}, hasSubQualifications: false
}

export const claimWizard = (state = claimWizardDefaults, action) => {

	// define involved parties fields
	const formFields = ['lastName', 'firstName', 'email', 'street', 'number', 'box', 'postalCode', 'town', 'country', 'phoneNumber',]
	const requiredFieldsMapping = {
		'Name': ['lastName'],
		'Mail': ['email'],
		'Phone': ['phoneNumber'],
		'Address': ['street', 'number', 'postalCode', 'town', 'country']
	}

	const generateStep3DocumentData = (doc, dsDocumentTemplates) => {
		const docData = {
			docType: doc.docType,
			digitalClaimDocuments: [],
			alternativeDocTypes: doc.alternativeDocTypes ? doc.alternativeDocTypes.map(option => {
				return {
					alternativeId: option.alternativeNr,
					alternativeLabel: option.alternativeId,
					alternatives: option.alternatives.map(alternative => {
						return {
							docType: alternative,
							hasDsDocumentTemplate: dsDocumentTemplates.some(template => template.active && template.indexType.lowValue === alternative)
						}
					})
				}
			}) : [],
			alternativeSelectionId: '',
			//check if a document has a dsDocumentTemplate
			hasDsDocumentTemplate: dsDocumentTemplates.some(template => template.active && template.indexType.lowValue === doc.docType),
		}
		return docData
	}

	switch (action.type) {
		case c.SET_CLAIM_WIZARD_STEP: {
			//if we are on step 3 we need to keep the document files otherwise we need to reset them
			let documentFiles = []
			if(action.wizardStep === '3' || action.wizardStep === '4') {
				documentFiles = state.documentFiles
			}
			return {
				...state,
				documentFiles,
				wizardStep: action.wizardStep
			}
		}
		case c.SET_CLAIM_WIZARD_DATA: {
			return {
				...state,
				claimData: { ...action.claimData },
			}
		}
		case c.TOGGLE_LEGAL_AID: {
			return {
				...state,
				isLegalAid: action.isLegalAid
			}
		}
		case c.SET_CLAIM_WIZARD_DOCUMENTATION: {
			const claimData = state.claimData
			const involvedPartiesData = []

			//generate mandatory fields for involved party
			action.involvedParties.forEach(oneInvParty => {
				const partyDataFields = {
					id: uuidv4(),
					partyNumber: oneInvParty.partyNumber,
					isMandatory: true,
					fields: {}
				}
				formFields.forEach(oneField => {
					partyDataFields.fields[oneField] = {
						value: oneField === 'country' ? '1' : '',
						required: Object.keys(requiredFieldsMapping).some(key => requiredFieldsMapping[key].includes(oneField) && oneInvParty.requiredFields.includes(key))
					}
				})
				involvedPartiesData.push(partyDataFields)
			})

			// set already existing party data 
			if (claimData.involvedParties) {

				claimData.involvedParties.forEach(oneClaimPartyData => {
					const index = involvedPartiesData.findIndex(oneParty => oneParty.partyNumber === oneClaimPartyData.partyNumber)

					//if fields are already created it means this party is mandatory and we only need to fill data out
					//if index <0 it means this party is optional and we need to add a new optional party 
					if (index > -1) {
						Object.keys(involvedPartiesData[index].fields).forEach(key => {
							involvedPartiesData[index].fields[key].value = oneClaimPartyData[key]
						})
					} else {
						const partyDataFields = {
							id: uuidv4(),
							partyNumber: oneClaimPartyData.partyNumber,
							isMandatory: false,
							fields: {}
						}
						formFields.forEach(oneField => {
							partyDataFields.fields[oneField] = {
								value: oneClaimPartyData[oneField],
								required: false
							}
						})
						involvedPartiesData.push(partyDataFields)
					}
				})
			}

			return {
				...state,
				documents: action.documents,
				involvedParties: action.involvedParties,
				optionalParties: action.optionalParties,
				// optionalPartyOptionsList,
				involvedPartiesData
			}
		}
		case c.ADD_OPTIONAL_PARTY: {
			const existingPartiesData = [...state.involvedPartiesData]
			const optionalParty = {
				id: uuidv4(),
				partyNumber: '',
				isMandatory: false,
				fields: {}
			}
			formFields.forEach(oneField => {
				optionalParty.fields[oneField] = {
					value: oneField === 'country' ? '1' : '',
					required: false
				}
			})
			existingPartiesData.push(optionalParty)
			return {
				...state,
				involvedPartiesData: [...existingPartiesData]
			}
		}
		case c.UPDATE_PARTY_FIELD: {
			const existingParties = [...state.involvedPartiesData]
			const index = existingParties.findIndex(oneParty => oneParty.id === action.partyId)

			if (index || index > -1) {
				if (action.field === 'partyNumber') {
					existingParties[index].partyNumber = action.value
				} else {
					existingParties[index].fields[action.field].value = action.value
				}
			}
			return {
				...state,
				involvedPartiesData: existingParties
			}
		}
		case c.REMOVE_OPTIONAL_PARTY: {
			const existingParties = [...state.involvedPartiesData]
			const index = existingParties.findIndex(oneParty => oneParty.id === action.partyId)
			if (index && index > -1) {
				existingParties.splice(index, 1)
			}
			return {
				...state,
				involvedPartiesData: existingParties
			}
		}
		case c.SET_DOCUMENTS_FOR_STEP_THREE: {
			const claimData = state.claimData
			const documents = state.documents
			const documentFiles = []
			const dsDocumentTemplates = action.dsDocumentTemplates
			const claimWizardDocumentsData = {
				wizardMandatory: [],
				claimMandatory: [],
				wizardOptional: []
			}
			//generate required documents for step 3 
			for (const doc of documents) {

				switch (doc.required.toUpperCase()) {
					case 'WIZARD':
						claimWizardDocumentsData.wizardMandatory.push(generateStep3DocumentData(doc, dsDocumentTemplates))
						break
					case 'CLOSE':
						claimWizardDocumentsData.claimMandatory.push(generateStep3DocumentData(doc, dsDocumentTemplates))
						break
					default:
						break
				}
			}
			//handle existing documents
			if (action.claimWizardDocuments) {
				for (const doc of action.claimWizardDocuments) {
					//add optional Documents to wizardOptional if we have any files for optional documents
					const documentIndex = documents.findIndex(oneDoc => oneDoc.docType === doc.docType)
					if (documentIndex > -1) {
						const document = documents[documentIndex]
						if (document.required.toUpperCase() === 'OPTIONAL' && !claimWizardDocumentsData.wizardOptional.some(oneDoc => oneDoc.docType === doc.docType)) {
							claimWizardDocumentsData.wizardOptional.push(generateStep3DocumentData(doc, dsDocumentTemplates))
						}
					}
					//handle alternative documents
					if (doc.mainDocType && doc.alternativeId) {
						const mainDocumentIndex = documents.findIndex(oneDoc => oneDoc.docType === doc.mainDocType)
						if (mainDocumentIndex > -1) {
							const mainDocument = documents[mainDocumentIndex]

							switch (mainDocument.required.toUpperCase()) {
								case 'WIZARD':
									const wizardMandatoryIndex = claimWizardDocumentsData.wizardMandatory.findIndex(oneDoc => oneDoc.docType === doc.mainDocType)
									if (wizardMandatoryIndex > -1) {
										claimWizardDocumentsData.wizardMandatory[wizardMandatoryIndex].alternativeSelectionId = doc.alternativeId
									}
									break
								case 'CLOSE':
									const claimMandatoryIndex = claimWizardDocumentsData.claimMandatory.findIndex(oneDoc => oneDoc.docType === doc.mainDocType)
									if (claimMandatoryIndex > -1) {
										claimWizardDocumentsData.claimMandatory[claimMandatoryIndex].alternativeSelectionId = doc.alternativeId
									}
									break
								case 'OPTIONAL':
									const claimOptionalIndex = claimWizardDocumentsData.wizardOptional.findIndex(oneDoc => oneDoc.docType === doc.mainDocType)
									claimWizardDocumentsData.wizardOptional[claimOptionalIndex].alternativeSelectionId = doc.alternativeId
									break
								default:
									break

							}
						}
					}
					documentFiles.push(doc)
				}
			}
			const dsPackages = {}
			// handle dsWizard Documents for step 3
			if (action.dsDocumentPackages) {
				for (const oneDsPackage of action.dsDocumentPackages) {
					for (const oneDocument of oneDsPackage.dsDocuments) {
						const docFile = {
							name: oneDocument.fileName,
							docType: oneDocument.origin === "DS_ORIGIN_LOCAL_UPLOAD" && oneDocument.documentTypeIdx || oneDocument.origin === "DS_ORIGIN_ORACLE" && oneDocument.documentTypeIdx
								|| oneDocument.documentTemplate && oneDocument.documentTemplate.indexType && oneDocument.documentTemplate.indexType.lowValue || '',
							uploaded: oneDocument.uploadedToOracle,
							dsPackageStatus: oneDsPackage.status,
							dsPackageId: oneDsPackage._id,
						}
						//check if document types are alternative types
						let alternativeId = null
						let mainDocType = null
						documents.forEach(oneDoc => {

							//in case there are dsDocuments for a optional document we need to add claimOptional to claimWizardDocumentsData
							if (claimWizardDocumentsData.wizardOptional.findIndex(doc => doc.docType === oneDoc.docType) === -1 && oneDoc.docType === docFile.docType
								&& oneDoc.required.toUpperCase() === 'OPTIONAL') {
								claimWizardDocumentsData.wizardOptional.push(generateStep3DocumentData(oneDoc, dsDocumentTemplates))
							}
							// check if the document is an alternative document
							if (oneDoc.docType === docFile.docType) {
								alternativeId = null
								mainDocType = null
							} else if (oneDoc.alternativeDocTypes && oneDoc.alternativeDocTypes.length > 0) {
								const alternativeDoc = oneDoc.alternativeDocTypes.find(oneAlternative => oneAlternative.alternatives.some(oneAlternative => oneAlternative === docFile.docType))
								if (alternativeDoc) {
									//data from oracle the actal id is in alternativeNr 
									alternativeId = alternativeDoc.alternativeNr
									mainDocType=oneDoc.docType
									switch (oneDoc.required.toUpperCase()) {
										case 'WIZARD':
											const wizardMandatoryIndex = claimWizardDocumentsData.wizardMandatory.findIndex(doc => doc.docType === oneDoc.docType)
											if (wizardMandatoryIndex > -1) {
												claimWizardDocumentsData.wizardMandatory[wizardMandatoryIndex].alternativeSelectionId = alternativeId
											}
											break
										case 'CLOSE':
											const claimMandatoryIndex = claimWizardDocumentsData.claimMandatory.findIndex(doc => doc.docType === oneDoc.docType)
											if (claimMandatoryIndex > -1) {
												claimWizardDocumentsData.claimMandatory[claimMandatoryIndex].alternativeSelectionId = alternativeId
											}
											break
										case 'OPTIONAL':
											const claimOptionalIndex = claimWizardDocumentsData.wizardOptional.findIndex(doc => doc.docType === oneDoc.docType)
											claimWizardDocumentsData.wizardOptional[claimOptionalIndex].alternativeSelectionId = alternativeId
											break
										default:
											break

									}
								}
							}
						})
						docFile.alternativeId = alternativeId
						docFile.mainDocType = mainDocType
						documentFiles.push(docFile)
					}
					dsPackages[oneDsPackage._id] = oneDsPackage
				}
			}

			return {
				...state,
				claimWizardDocumentsData,
				dsDocumentTemplates,
				documentFiles,
				dsPackages
			}
		}
		case c.ADD_OPTIONAL_CLAIM_DOCUMENT: {
			const claimWizardDocumentsData = { ...state.claimWizardDocumentsData }
			const newDocument = {
				id: uuidv4(),
				docType: '',
				digitalClaimDocuments: [],
				alternativeDocTypes: [],
				alternativeSelectionId: '',
				hasDsDocumentTemplate: false
			}
			claimWizardDocumentsData.wizardOptional.push(newDocument)

			return {
				...state,
				claimWizardDocumentsData
			}
		}
		case c.UPDATE_CLAIM_WIZARD_OPTIONAL_DOCUMENT: {
			const wizardOptionalDocs = [...state.claimWizardDocumentsData.wizardOptional]
			const documents = state.documents
			const dsDocumentTemplates = state.dsDocumentTemplates
			const index = wizardOptionalDocs.findIndex(oneDoc => oneDoc.id === action.tempId)
			if (index > -1) {
				const docType = action.docType
				const document = documents.find(oneDoc => oneDoc.docType === docType)
				const docData = generateStep3DocumentData(document, dsDocumentTemplates)
				wizardOptionalDocs[index] = { ...wizardOptionalDocs[index], ...docData }
			}

			return {
				...state,
				claimWizardDocumentsData: {
					...state.claimWizardDocumentsData,
					wizardOptional: wizardOptionalDocs
				}
			}
		}
		case c.REMOVE_CLAIM_WIZARD_OPTIONAL_DOCUMENT: {
			const claimWizardDocumentsData = state.claimWizardDocumentsData
			const wizardOptionalDocs = claimWizardDocumentsData.wizardOptional
			const index = wizardOptionalDocs.findIndex(oneDoc => oneDoc.id === action.tempId)
			if (index > -1) {
				wizardOptionalDocs.splice(index, 1)
			}

			return {
				...state,
				claimWizardDocumentsData: {
					...claimWizardDocumentsData,
					wizardOptional: wizardOptionalDocs
				}
			}
		}
		case c.SET_ALTERNATIVE_DOC_TYPE: {
			const claimWizardDocumentsData = state.claimWizardDocumentsData
			const docType = action.docType
			const alternativeSelectionId = action.alternativeSelectionId
			const documents = claimWizardDocumentsData.wizardMandatory.concat(claimWizardDocumentsData.claimMandatory, claimWizardDocumentsData.wizardOptional)

			for (const doc of documents) {
				if (doc.docType === docType) {
					doc.alternativeSelectionId = alternativeSelectionId
				}
			}

			return {
				...state,
				claimWizardDocumentsData
			}
		}
		case c.ADD_FILES_TO_CLAIM_WIZARD: {
			const documentFiles = [...state.documentFiles]
			const files = action.files

			documentFiles.push(...files)

			return {
				...state,
				documentFiles
			}
		}
		case c.REMOVE_DOCUMENT_FILE_FROM_CLAIM_WIZARD: {
			const documentFiles = [...state.documentFiles]
			const index = documentFiles.findIndex(oneFile => oneFile.fileId === action.fileId)
			if (index > -1) {
				documentFiles.splice(index, 1)
			}

			return {
				...state,
				documentFiles
			}
		}
		case c.UPDATE_FILE_UPLOAD_STATUS: {
			const documentFiles = [...state.documentFiles]
			const index = documentFiles.findIndex(oneFile => oneFile.fileId === action.fileId)
			if (index > -1) {
				switch (action.status) {
					case 'success':
						documentFiles[index].uploaded = true
						break;
					case 'failed':
						documentFiles[index].uploaded = false
						documentFiles[index].error = action.message
						break;
					default:
						break;
				}
			}

			return {
				...state,
				documentFiles
			}
		}
		case c.RESET_CLAIM_WIZARD: {
			return {
				...state,
				...claimWizardDefaults,
				claimWizardPackages: state.claimWizardPackages
			}
		}

		case c.SET_ALL_CLAIMWIZARD_PACKAGES: {
			if (action.claimWizardPackages) {
				return {
					...state,
					claimWizardPackages: action.claimWizardPackages,
				}
			} 
		}

		case c.SET_CLAIM_WIZARD_SUBQUALIFICATION: {
			return {
				...state,
				hasSubQualifications: action.hasSubQualifications
			}
		}
		
		case c.CLEAR_CLAIM_WIZARD_PACKAGES: {
			return {
				...state,
				claimWizardPackages: []
			}
		}

		default: {
			return state
		}
	}
}




// WEBPACK FOOTER //
// ./state/reducers.js